import { ProductInventoryComponent } from './partials/product-inventory/product-inventory.component';
import { ProductPricingV2Component } from './partials/product-pricing-v2/product-pricing-v2.component';
import { GlobalService } from 'src/app/_services/global.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { VendorsService } from 'src/app/_services/vendors.service';
import { ManufacturersService } from 'src/app/_services/manufacturers.service';
import { CategoryService } from 'src/app/_services/category.service';
import { ProductsService } from 'src/app/_services/products.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductDetailsComponent } from './partials/product-details/product-details.component';

import { DepartmentService } from 'src/app/_services/department.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { BarcodeLabelPrintingService } from 'src/app/_services/barcode-label-printing.service';
import { ProductVariantsComponent } from './partials/product-variants/product-variants.component';
import { isProductVariantFeatureEnabled } from 'src/app/utils/product-variant-feature';
import { suggestedCategories } from 'src/app/utils/industry-category-suggestions';
import { Observable, firstValueFrom, map } from 'rxjs';

@Component({
  selector: 'app-create-product-v3',
  templateUrl: './create-product-v3.component.html',
  styleUrls: ['./create-product-v3.component.scss']
})
export class CreateProductV3Component implements OnInit, AfterViewInit, DoCheck {
  variantLinkOptions: Array<{ label: string; value: string }> = [];
  selectedVariantLink: string | null = null;
  private variantLinkSignature = '';

  @Input() isEmbeddedView = false
  @Output() closeEmbedded = new EventEmitter<void>()

  private readonly hiddenVariantsIdentifiers = new Set<string>();
  private readonly colorHexByName: Record<string, string> = {
    beige: '#f3e5c0',
    black: '#111827',
    blue: '#2563eb',
    bronze: '#cd7f32',
    brown: '#92400e',
    clear: '#e5e7eb',
    gold: '#f59e0b',
    gray: '#9ca3af',
    green: '#16a34a',
    navy: '#1e3a8a',
    orange: '#f97316',
    pink: '#ec4899',
    purple: '#7c3aed',
    red: '#dc2626',
    silver: '#cbd5f5',
    teal: '#0d9488',
    white: '#ffffff',
    yellow: '#facc15'
  }
  activeStateB: boolean[] = [true, true, true, true];
  inventorySectionError = false;
  additionalDetailsError = false;
  editform!: FormGroup
  // Label Printing 
  labelForm: FormGroup
  selectedTemplate: any = null;
  dummyImageData = "https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg";

  fileToUpload: any;

  isNew = true
  tobesaved = false
  /** New-product-only choice between the full form (unchanged) and a trimmed view that stops
   *  after Gallery Images — the Variants block and the whole "Additional Details" accordion stay
   *  mounted (hidden via CSS, not *ngIf) so their auto-generated defaults from prepareNewItem()
   *  (SKU/barcode/category/etc.) keep validToSave() passing without the merchant touching them. */
  addMode: 'quick' | 'detail' = 'detail'

  get isQuickMode(): boolean {
    return this._productService.isNew && this.addMode === 'quick'
  }

  saveMenuItems: MenuItem[] = [
    {
      label: 'Save',
      icon: 'pi pi-check',
      command: () => this.saveProductClick('save-only'),
    },
    {
      label: 'Cancel',
      icon: 'pi pi-times',
      command: () => this.cancelClick(),
    },
    {
      label: 'Save as Duplicate',
      icon: 'pi pi-copy',
      command: () => this.saveProductClick('save-and-duplicate'),
    },
  ];
  private readonly sellChipOptionsBase = [
    { label: 'Online', value: 'online', id: 1 },
    { label: 'In-store', value: 'offline', id: 2 },
  ];
  sellChipOptions = [...this.sellChipOptionsBase];
  selectedSellChips: string[] = [];
  // Set when an existing product's saved channel is no longer entitled by the current plan
  // (e.g. saved as In-store, plan since switched to Online-only). Lets the template warn the
  // merchant instead of silently swapping the channel out from under them.
  disabledSavedSellTypeLabel: string | null = null;
  categoryMetafields = [
    { key: 'color', label: 'Color', defaults: ['Beige', 'Black', 'Blue', 'Bronze', 'Brown', 'Clear', 'Gold', 'Gray', 'Green', 'Navy', 'Orange', 'Pink', 'Purple', 'Red', 'Silver', 'Teal', 'White', 'Yellow'] },
    { key: 'age_group', label: 'Age group', defaults: ['0-6 months', '6-12 months', '1-2 years', '2-4 years', '4-6 years', '6-8 years', '8-10 years', '10-12 years', 'Teens', 'Adults', 'All ages', 'Babies', 'Kids', 'Newborn', 'Toddlers'] },
    { key: 'fit', label: 'Fit', defaults: ['Slim', 'Regular', 'Relaxed', 'Oversized'] },
    { key: 'waist_rise', label: 'Waist rise', defaults: ['High', 'Mid', 'Low'] },
    { key: 'target_gender', label: 'Target gender', defaults: ['Female', 'Male', 'Unisex', 'Other'] },
    { key: 'pants_length', label: 'Pants length type', defaults: ['Short', 'Regular', 'Long'] },
    { key: 'care_instructions', label: 'Care instructions', defaults: ['Machine wash', 'Hand wash', 'Dry clean', 'Tumble dry low', 'Do not bleach', 'Do not tumble dry', 'Iron low', 'Line dry'] },
    { key: 'fabric', label: 'Fabric', defaults: ['Acrylic', 'Angora', 'Bamboo', 'Canvas', 'Cashmere', 'Corduroy', 'Cork', 'Cotton', 'Denim', 'Faux fur', 'Felt', 'Fleece', 'Leather', 'Linen', 'Mesh', 'Nylon', 'Polyester', 'Rayon', 'Rubber', 'Satin', 'Silk', 'Spandex', 'Suede', 'Tweed', 'Velvet', 'Wool'] },
    { key: 'size', label: 'Size', defaults: ['3XS', '2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'] },
    { key: 'clothing_features', label: 'Clothing features', defaults: ['Stretch', 'Breathable', 'Moisture wicking', 'Wrinkle resistant', 'Insulated', 'Water resistant'] }
  ];
  selectedCategoryMetafields = new Set<string>();
  metafieldValues: Record<string, { selected: string[]; custom: string[]; draft: string }> = {};
  get saveMenuItemsStateful(): MenuItem[] {
    // Leave items clickable; saveProductClick guards validity internally.
    return this.saveMenuItems;
  }

  items: MenuItem[] = [
    { label: 'General', icon: 'pi pi-fw pi-home' },
    { label: 'Product Images', icon: 'pi pi-fw pi-file' },
    { label: 'Stock Management', icon: 'pi pi-fw pi-calendar' },
    { label: 'Shipping', icon: 'pi pi-fw pi-plus-circle' },
    { label: 'Additional', icon: 'pi pi-fw pi-plus-circle' },
    { label: 'Print Label', icon: 'pi pi-fw pi-print', visible: this.isNew },
  ]

  activeItem: any = { label: 'General', icon: 'pi pi-fw pi-home' }
  isVariantsFeatureEnabled = false;
  thFiles: any = ''
  isFreeTrialPlan = false

  get hasVariants(): boolean {
    return Array.isArray(this._productService.variantAttributes) && this._productService.variantAttributes.length > 0;
  }

  // "Where to Sell" channel availability is a plan entitlement, not the free-trial flag —
  // standardOnlineStore gates Online, hasPOS/hasPOSLite (either one) gates In-store.
  get canSellOnline(): boolean {
    return !!this._globals.userInfo?.businessSetup?.[0]?.standardOnlineStore;
  }

  get canSellInStore(): boolean {
    const businessSetup = this._globals.userInfo?.businessSetup?.[0];
    return !!(businessSetup?.hasPOS || businessSetup?.hasPOSLite);
  }

  @ViewChild('fileInput') fileInput: FileUpload;
  @ViewChild(ProductDetailsComponent) __productDetail!: ProductDetailsComponent
  @ViewChild(ProductPricingV2Component) __productPricing!: ProductPricingV2Component
  @ViewChild(ProductInventoryComponent) __productInventory!: ProductInventoryComponent
  @ViewChild(ProductVariantsComponent) __productVariants!: ProductVariantsComponent
  _globals = GlobalService
  categoryOptions$: Observable<any[]>;

  tagsForm: FormGroup;
  alreadyExistBarcodes: any;

  tempImageUrl = ""
  tempItemImage: any;
  // activeTemplateId = 1;
  templateList: any[] = [
    { templateId: 1, templateName: 'QR Code - with Business Name', templateURL: 'assets/images/qr_code_with_business_name.png' },
    { templateId: 2, templateName: 'QR Code - without Business Name', templateURL: 'assets/images/qr_code_without_business_name.png' },
    { templateId: 3, templateName: 'Barcode - with Logo', templateURL: 'assets/images/barcode_with_logo.png' },
    { templateId: 4, templateName: 'Barcode - without Logo', templateURL: 'assets/images/barcode_without_logo.png' },
    { templateId: 5, templateName: 'Barcode - complete Details', templateURL: 'assets/images/barcode_with_compete_details.png' },
  ]
  selectedBrand: any = null;
  selectedlabelSizes: any = null;
  selectedlabelStyle: any = null
  configuration: any = [];

  constructor(
    public _reportService: ReportsService,
    public _catService: CategoryService,
    public _manufacturers: ManufacturersService,
    public _vendors: VendorsService,
    public _productService: ProductsService,
    public _abd: AppBaseDataService,
    private _connMessageService: ConnMessageService,
    private _spinner: NgxSpinnerService,
    private _fb: FormBuilder,
    public _departmentService: DepartmentService,
    private _router: Router,
    private _route: ActivatedRoute,
    public _platform: Platform,
    public _barcodeLabelServices: BarcodeLabelPrintingService,
    private _confirmationService: ConfirmationService,
    private cd: ChangeDetectorRef
  ) { }
  selectedProductSellType = { Type: "All", id: 3, show: true }

  get shouldHideVariantsForCurrentUser(): boolean {
    const localUser = this.safeParseJson(localStorage.getItem('user'));
    const loginUser = this.safeParseJson(sessionStorage.getItem('login-user'));
    const identifiers = [
      this._globals.userInfo?.username,
      this._globals.userInfo?.userName,
      this._globals.userInfo?.email,
      localUser?.userName,
      localUser?.username,
      localUser?.email,
      loginUser?.Username,
      loginUser?.username,
      loginUser?.email
    ]
      .map((value) => String(value || '').trim().toLowerCase())
      .filter((value) => value.length > 0);

    return identifiers.some((value) => this.hiddenVariantsIdentifiers.has(value));
  }

  get selectedCategoryLabel(): string {
    return this._abd.selectedCategory?.categoryName || 'Category';
  }

  get selectedMetafieldsList() {
    return this.categoryMetafields.filter((field) => this.selectedCategoryMetafields.has(field.key));
  }

  isMetafieldSelected(fieldKey: string): boolean {
    return this.selectedCategoryMetafields.has(fieldKey);
  }

  toggleMetafield(fieldKey: string): void {
    if (this.selectedCategoryMetafields.has(fieldKey)) {
      this.selectedCategoryMetafields.delete(fieldKey);
    } else {
      this.selectedCategoryMetafields.add(fieldKey);
      if (!this.metafieldValues[fieldKey]) {
        this.metafieldValues[fieldKey] = { selected: [], custom: [], draft: '' };
      }
    }
  }

  onMetafieldDefaultsChange(fieldKey: string, values: string[]): void {
    if (!this.metafieldValues[fieldKey]) {
      this.metafieldValues[fieldKey] = { selected: [], custom: [], draft: '' };
    }
    this.metafieldValues[fieldKey].selected = values || [];
  }

  getMetafieldValues(fieldKey: string): string[] {
    const entry = this.metafieldValues[fieldKey];
    if (!entry) return [];
    const combined = [...(entry.selected || []), ...(entry.custom || [])];
    return Array.from(new Set(combined));
  }

  addCustomMetafieldValue(fieldKey: string): void {
    const entry = this.metafieldValues[fieldKey];
    if (!entry) return;
    const raw = entry.draft || '';
    const parts = raw
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length);
    if (!parts.length) return;
    const next = Array.from(new Set([...(entry.custom || []), ...parts]));
    entry.custom = next;
    entry.draft = '';
  }

  removeMetafieldValue(fieldKey: string, value: string): void {
    const entry = this.metafieldValues[fieldKey];
    if (!entry) return;
    entry.selected = (entry.selected || []).filter((item) => item !== value);
    entry.custom = (entry.custom || []).filter((item) => item !== value);
  }

  private safeParseJson(raw: string | null): any {
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  ngOnInit(): void {
    this.isVariantsFeatureEnabled = isProductVariantFeatureEnabled();
    this.categoryOptions$ = this._abd.categories$.pipe(map((categories: any[]) => this.buildCategoryOptions(categories)));

    // Chosen on the products list's "Add new product" dropdown (report-top-filter-bar.component.ts's
    // navigateToAddProduct()) and passed as router state rather than a query param, matching
    // business-setup-checklist.component.ts's openSectionFromQueryParam() pattern.
    const navigationState = this._router.getCurrentNavigation()?.extras?.state ?? history.state;
    if (navigationState?.addMode === 'quick' || navigationState?.addMode === 'detail') {
      this.addMode = navigationState.addMode;
    }

    if (!this._productService.activeItem) {
      // Default to new mode when no product is selected (direct navigation)
      this._productService.isNew = true
      this._productService.isEdit = false
      this._productService.isViewOnly = false
      this._productService.featureImage = null
      this._productService.thImages = []
      this._productService.thImageNames = []
    }

    this._abd.resetAllBehaviorSubjects()
    this.isFreeTrialPlan = !!this._globals.userInfo?.businessSetup?.[0]?.isFreeTrial
    // this.activeTemplate(1)
    // try {
    //   const abd = this._abd
    //   if (abd.departments.length < 1 || abd.categories.length < 1 || abd.manufacturers.length < 1 || abd.vendors.length < 1) {
    //     this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
    //     window.history.back()
    //   }
    // } catch {
    //   this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
    //   window.history.back()
    // }
    this.initForm()
    // this.getLabelPrinterConfiguration()
    this.labelForm.valueChanges.subscribe((v) => {
      this.labelForm.markAllAsTouched()
      this.labelForm.markAsDirty()
    })
    if (this._productService.activeItem) {
      this.items = [
        { label: 'General', icon: 'pi pi-fw pi-home' },
        { label: 'Product Images', icon: 'pi pi-fw pi-file' },
        { label: 'Stock Management', icon: 'pi pi-fw pi-calendar' },
        { label: 'Shipping', icon: 'pi pi-fw pi-plus-circle' },
        { label: 'Additional', icon: 'pi pi-fw pi-plus-circle' },
        // { label: 'Print Label', icon: 'pi pi-fw pi-print',visible:this.isNew},
      ]
      this.prepareEditItem()
    }
    else {
      // const actloc = this._abd.initActLocations()
      // if (!actloc || actloc.length < 1) {
      //   this._connMessageService.showToastMessage('No active location available.', 'error');
      //   window.history.back()
      // }

      this.restAllFields()
      this.prepareNewItem()
    }
    this.refreshUomData()
    this.syncSellChipSelection();

    if (!this._abd.uom?.length) {
      this._abd.loadInit().subscribe(res => {
        if (res.success) {
          if (!this._productService.activeItem) {
            this.getInitData()
          }
          this.refreshUomData()
        }
      })
    }
  }


  getLabelPrinterConfiguration() {
    try {
      this._barcodeLabelServices.getbarcodeLabelConfiguration().subscribe(res => {
        if (res.success) {
          const rawConfiguration = Array.isArray(res?.data) ? res.data : []
          this.configuration = rawConfiguration
            .filter((val) => !!val)
            .map((val) => {
              const brand = String(val?.brand ?? '').trim()
              const model = String(val?.model ?? '').trim()
              const labelFormats = Array.isArray(val?.labelFormats) ? val.labelFormats : []
              const brandName = model ? `${brand} (${model})` : brand

              return {
                brandName,
                brand,
                model,
                image: val?.image,
                labelSizes: labelFormats.map((x) => {
                  const styles = Array.isArray(x?.styles) ? x.styles : []
                  return {
                    name: x?.name,
                    style: styles.map((s) => {
                      return {
                        name: s?.label,
                        image: s?.image
                      }
                    })
                  }
                })
              }
            })
            .filter((entry) => !!entry.brand || !!entry.model)

          if (this.selectedBrand && !this.configuration.includes(this.selectedBrand)) {
            this.selectedBrand = null
            this.selectedlabelSizes = null
            this.selectedlabelStyle = null
          }

        }
      })
    } catch {
      this._connMessageService.showToastMessage('Label printing configuration fail to load', 'error');

    }
  }


  ngOnDestroy() {
    this.restAllFields()
    this._productService.resetVariables()
  }

  /** Keeps the "Link for" dropdown in sync with saved variants (rows that have a skuId). */
  ngDoCheck() {
    const rows = this.__productVariants?.variantRows || [];
    const options = rows
      .filter((r) => r.skuId !== undefined && r.skuId !== null && String(r.skuId).trim())
      .map((r) => ({ label: Object.values(r.options || {}).join(' / ') || r.sku, value: String(r.skuId).trim() }));
    const signature = options.map((o) => `${o.value}:${o.label}`).join('|');
    if (signature === this.variantLinkSignature) return;
    this.variantLinkSignature = signature;
    this.variantLinkOptions = options;
    if (!options.some((o) => o.value === this.selectedVariantLink)) {
      this.selectedVariantLink = options[0]?.value ?? null;
    }
  }

  getLinkUrl(baseUrl: string): string {
    return this.selectedVariantLink ? `${baseUrl}?skuitemid=${this.selectedVariantLink}` : baseUrl;
  }

  getLinkCartUrl(baseUrl: string): string {
    return `${baseUrl}${this.selectedVariantLink ? `?skuitemid=${this.selectedVariantLink}&` : '?'}add-to-cart`;
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
    this.removeNoBannerClass();
    this.updateAdditionalDetailsError();
    this.subscribeToSectionValidity();
    //console.log(`ngAfterViewInit - jokeViewChild is ${this.__productInventory}`)
  }

  whereToSellChanged() {
    this.updateSellFlagsFromChips();
  }

  async prepareEditItem() {
    this.isNew = false
    const item = this._productService.activeItem
    this._productService.useParentSkuBarcodeForVariants = false
    
    const rawVariants = item?.VariantAttributes ?? item?.variantAttributes ?? [];
    const optionModels = item?.ItemVariantOptions ?? item?.itemVariantOptions ?? [];
    const valueModels = item?.ItemVariantOptionValues ?? item?.itemVariantOptionValues ?? [];
    const combinationModels = item?.ItemVariantCombinations ?? item?.itemVariantCombinations ?? [];
    const itemSkus = this.getItemSkuList(item);
    //console.log('<< EDIT-ITEM >>', this._productService.activeItem)

    // Reset images so edits start from the current product state only
    this.populateImagesFromActiveItem(item);

    this._productService.isReturnable = item.isReturnable
    this._productService.pts.t_productName = item.itemName
    this._productService.pts.descriptionUrl = item.descriptionURL
    this._productService.isPrintAsQR = item.printAsQRCodeOnReceipt
    this._productService.productDescription = item.description
    const baseSku = this.getPrimarySkuFromList(itemSkus) || {};
    const openingStocks = item?.OpeningStocks ?? item?.openingStocks ?? [];

    let sortedOptionModels: any[] = [];
    if (Array.isArray(optionModels) && optionModels.length && Array.isArray(valueModels)) {
      const valuesByOptionId = new Map<any, Array<any>>();
      valueModels.forEach((value) => {
        const optionId = value?.OptionId ?? value?.optionId;
        if (optionId === undefined || optionId === null) return;
        if (!valuesByOptionId.has(optionId)) valuesByOptionId.set(optionId, []);
        valuesByOptionId.get(optionId)?.push(value);
      });
      const sortedOptions = [...optionModels].sort((a, b) => {
        const aOrder = a?.SortOrder ?? a?.sortOrder ?? 0;
        const bOrder = b?.SortOrder ?? b?.sortOrder ?? 0;
        return aOrder - bOrder;
      });
      sortedOptionModels = sortedOptions;
      this._productService.variantAttributes = sortedOptions.map((option, index) => {
        const optionId = option?.Id ?? option?.id ?? option?.OptionId ?? option?.optionId ?? null;
        const optionName = option?.OptionName ?? option?.optionName ?? option?.Name ?? option?.name ?? '';
        const sortOrder = option?.SortOrder ?? option?.sortOrder ?? option?.position ?? index + 1;
        const values = valuesByOptionId.get(optionId) || [];
        const sortedValues = [...values].sort((a, b) => {
          const aOrder = a?.SortOrder ?? a?.sortOrder ?? 0;
          const bOrder = b?.SortOrder ?? b?.sortOrder ?? 0;
          return aOrder - bOrder;
        });
        const valueIds: Record<string, number | string> = {};
        const colorValueMap: Record<string, string> = {};
        const mappedValues = sortedValues
          .map((entry) => {
            const display =
              entry?.DisplayValue ?? entry?.displayValue ?? entry?.Value ?? entry?.value ?? '';
            const storageValue = String(entry?.Value ?? entry?.value ?? '').trim();
            const id = entry?.Id ?? entry?.id ?? entry?.OptionValueId ?? entry?.optionValueId ?? null;
            if (display && id !== null && id !== undefined) {
              valueIds[display] = id;
            }
            if (this.isColorOptionName(optionName) && display && this.normalizeHexValue(storageValue)) {
              colorValueMap[display] = storageValue;
            }
            return display;
          })
          .filter((value) => !!value);
        return {
          id: optionId,
          name: optionName,
          values: mappedValues,
          position: sortOrder,
          valueIds: Object.keys(valueIds).length ? valueIds : undefined,
          colorValueMap: Object.keys(colorValueMap).length ? colorValueMap : undefined
        };
      });
    } else if (typeof rawVariants === 'string') {
      try {
        this._productService.variantAttributes = JSON.parse(rawVariants);
      } catch {
        this._productService.variantAttributes = [];
      }
    } else if (Array.isArray(rawVariants)) {
      this._productService.variantAttributes = rawVariants;
    } else {
      this._productService.variantAttributes = [];
    }

    if (sortedOptionModels.length && (!Array.isArray(valueModels) || !valueModels.length)) {
      const optionOrder = [...sortedOptionModels].sort((a, b) => {
        const aOrder = a?.SortOrder ?? a?.sortOrder ?? 0;
        const bOrder = b?.SortOrder ?? b?.sortOrder ?? 0;
        return aOrder - bOrder;
      });
      const optionNames = optionOrder
        .map((opt) => String(opt?.OptionName ?? opt?.optionName ?? opt?.Name ?? opt?.name ?? '').trim())
        .filter((name) => !!name);
      const derivedValues = this.collectVariantValuesFromSkus(itemSkus, item?.itemName ?? '', optionNames);
      if (derivedValues.size) {
        this._productService.variantAttributes = (this._productService.variantAttributes || []).map((attr: any, idx: number) => {
          const name = String(attr?.name ?? attr?.Name ?? optionNames[idx] ?? '').trim();
          const existingValues = Array.isArray(attr?.values) ? attr.values : [];
          const derived = derivedValues.get(name);
          if (!existingValues.length && derived && derived.size) {
            return { ...attr, values: Array.from(derived) };
          }
          return attr;
        });
      }
    }

    this._productService.variantImages =
      item?.VariantImages ?? item?.variantImages ?? [];
    let builtVariantRows = false;

    if (
      Array.isArray(optionModels) &&
      optionModels.length &&
      Array.isArray(valueModels) &&
      valueModels.length &&
      Array.isArray(combinationModels) &&
      combinationModels.length &&
      Array.isArray(itemSkus) &&
      itemSkus.length
    ) {
      const optionIdToName = new Map<any, string>();
      optionModels.forEach((option) => {
        const optionId = option?.Id ?? option?.id ?? option?.OptionId ?? option?.optionId;
        const optionName = option?.OptionName ?? option?.optionName ?? option?.Name ?? option?.name ?? '';
        if (optionId !== undefined && optionId !== null) {
          optionIdToName.set(optionId, optionName);
        }
      });
      const valueIdToValue = new Map<any, string>();
      valueModels.forEach((value) => {
        const valueId = value?.Id ?? value?.id ?? value?.OptionValueId ?? value?.optionValueId;
        const display = value?.DisplayValue ?? value?.displayValue ?? value?.Value ?? value?.value ?? '';
        if (valueId !== undefined && valueId !== null) {
          valueIdToValue.set(valueId, display);
        }
      });
      const combosBySkuId = new Map<any, Array<any>>();
      combinationModels.forEach((combo) => {
        const skuId = combo?.ItemSKUId ?? combo?.itemSKUId ?? combo?.itemSkuId;
        if (skuId === undefined || skuId === null) return;
        if (!combosBySkuId.has(skuId)) combosBySkuId.set(skuId, []);
        combosBySkuId.get(skuId)?.push(combo);
      });

      const optionOrder = [...this._productService.variantAttributes].sort((a: any, b: any) => {
        const aOrder = a?.position ?? a?.SortOrder ?? 0;
        const bOrder = b?.position ?? b?.SortOrder ?? 0;
        return aOrder - bOrder;
      });
      const optionNames = optionOrder.map((opt: any) => opt?.name).filter((name: string) => !!name);

      const nextRows: Array<any> = [];
      const rowIdBySkuCode = new Map<string, string>();
      const rowIdBySkuId = new Map<string, string>();
      itemSkus.forEach((sku) => {
        const skuId = sku?.Id ?? sku?.id ?? sku?.itemSKUId ?? sku?.itemSkuId ?? null;
        const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '');
        const combos = combosBySkuId.get(skuId) || [];
        if (!skuCode || !combos.length) return;
        const options: Record<string, string> = {};
        combos.forEach((combo) => {
          const optionId = combo?.OptionId ?? combo?.optionId;
          const valueId = combo?.OptionValueId ?? combo?.optionValueId;
          const optionName = optionIdToName.get(optionId) || '';
          const optionValue = valueIdToValue.get(valueId) || '';
          if (optionName && optionValue) {
            options[optionName] = optionValue;
          }
        });
        const orderedOptions: Record<string, string> = {};
        optionNames.forEach((name: string) => {
          const value = options[name];
          if (value !== undefined && value !== null && String(value).trim() !== '') {
            orderedOptions[name] = value;
          }
        });
        Object.entries(options).forEach(([name, value]) => {
          if (!(name in orderedOptions)) {
            orderedOptions[name] = value;
          }
        });
        const rowId = optionNames
          .map((name) => `${name}:${orderedOptions[name] ?? ''}`)
          .join('|');
        if (skuCode && !rowIdBySkuCode.has(skuCode)) {
          rowIdBySkuCode.set(skuCode, rowId);
        }
        if (skuId !== undefined && skuId !== null && String(skuId).trim()) {
          rowIdBySkuId.set(String(skuId).trim(), rowId);
        }
        const salePrice = sku?.salePrice ?? sku?.salePriceA ?? sku?.salePriceB ?? sku?.salePriceC ?? 0;
        const skuImage = sku?.skuImage ?? sku?.SKUImage ?? sku?.image ?? sku?.Image ?? null;
        nextRows.push({
          id: rowId,
          options: orderedOptions,
          price: typeof salePrice === 'number' ? salePrice : Number(salePrice) || 0,
          available: this.getVariantQuantityForSku(sku, openingStocks),
          image: skuImage,
          sku: skuCode,
          barcode: String(sku?.barcode ?? sku?.Barcode ?? ''),
          skuId: skuId,
          ...this.extractSkuShippingFields(sku)
        });
      });
      builtVariantRows = nextRows.length > 0 && nextRows.length === itemSkus.length;
      if (builtVariantRows) {
        this._productService.variantRows = nextRows;
        const locationStocks = this.buildVariantLocationStocks(rowIdBySkuId, rowIdBySkuCode, openingStocks, itemSkus);
        this._productService.variantLocationStocks = locationStocks;
        this._productService.variantLocationQohStocks = JSON.parse(JSON.stringify(locationStocks));
      }
    }
    if (
      !builtVariantRows &&
      Array.isArray(itemSkus) &&
      itemSkus.length &&
      Array.isArray(this._productService.variantAttributes) &&
      this._productService.variantAttributes.length
    ) {
      const optionOrder = [...this._productService.variantAttributes].sort((a: any, b: any) => {
        const aOrder = a?.position ?? a?.SortOrder ?? 0;
        const bOrder = b?.position ?? b?.SortOrder ?? 0;
        return aOrder - bOrder;
      });
      const optionNames = optionOrder
        .map((opt: any) => String(opt?.name ?? opt?.Name ?? '').trim())
        .filter((name: string) => !!name);
      const expectedCount = optionNames.length;
      if (expectedCount) {
        const nextRows: Array<any> = [];
        const rowIdBySkuCode = new Map<string, string>();
        const rowIdBySkuId = new Map<string, string>();
        itemSkus.forEach((sku, index) => {
          const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim();
          const parts = this.extractVariantValuesFromSkuTitle(sku, item?.itemName ?? '', expectedCount);
          if (!parts.length) return;
          const options: Record<string, string> = {};
          parts.forEach((value, idx) => {
            const optionName = optionNames[idx];
            if (optionName) {
              options[optionName] = value;
            }
          });
          const rowId = optionNames.map((name) => `${name}:${options[name] ?? ''}`).join('|');
          if (skuCode && !rowIdBySkuCode.has(skuCode)) {
            rowIdBySkuCode.set(skuCode, rowId);
          }
          const salePrice = sku?.salePrice ?? sku?.salePriceA ?? sku?.salePriceB ?? sku?.salePriceC ?? 0;
          const skuId = sku?.Id ?? sku?.id ?? sku?.itemSKUId ?? sku?.itemSkuId ?? null;
          const skuImage = sku?.skuImage ?? sku?.SKUImage ?? sku?.image ?? sku?.Image ?? null;
          if (skuId !== undefined && skuId !== null && String(skuId).trim()) {
            rowIdBySkuId.set(String(skuId).trim(), rowId);
          }
          nextRows.push({
            id: rowId,
            options,
            price: typeof salePrice === 'number' ? salePrice : Number(salePrice) || 0,
            available: this.getVariantQuantityForSku(sku, openingStocks),
            image: skuImage,
            sku: skuCode,
            barcode: String(sku?.barcode ?? sku?.Barcode ?? ''),
            skuId: skuId,
            sortOrder: index,
            ...this.extractSkuShippingFields(sku)
          });
        });
        if (nextRows.length) {
          this._productService.variantRows = nextRows;
          builtVariantRows = true;
          const locationStocks = this.buildVariantLocationStocks(rowIdBySkuId, rowIdBySkuCode, openingStocks, itemSkus);
          this._productService.variantLocationStocks = locationStocks;
          this._productService.variantLocationQohStocks = JSON.parse(JSON.stringify(locationStocks));
        }
      }
    }
    if (!builtVariantRows) {
      this._productService.variantRows = [];
      this._productService.variantLocationStocks = {};
      this._productService.variantLocationQohStocks = {};
    }

    let temp: any = ''
    temp = this.findProductInfoOption(this._productService.productInfo?.itemType, item.itemType ?? item.ItemType)
    this._productService.selectedProductType = temp

    temp = this.findProductInfoOption(this._productService.productInfo?.sellAs, item.soldAs ?? item.SoldAs)
    this._productService.selectedSellAs = temp

    temp = this.findProductInfoOption(this._productService.productInfo?.grouping, item.grouping ?? item.Grouping)
    this._productService.selectedGrouping = temp

    temp = this.findProductInfoOption(this._productService.productInfo?.discount, item.allowDiscount ?? item.AllowDiscount)
    this._productService.selectedDiscount = temp

    temp = this.findProductInfoOption(this._productService.productInfo?.ageRestriction, item.ageRestriction ?? item.AgeRestriction)
    this._productService.selectedAgeRestriction = temp

    temp = this.findProductInfoOption(this._productService.productInfo?.gender, item.gender ?? item.Gender)
    this._productService.selectedGender = temp
    //-- inventory
    this._productService.pts.sku = baseSku.skuCode ?? ''
    this._productService.pts.barcode = baseSku.barcode ?? ''
    // -- Secondary SKU & Barcode
    // --BST--
    this._productService.pts.altBarcode = baseSku?.barcodes ?? []
    this._productService.pts.altSKUs = baseSku?.skus ?? []
    this._productService.pts.altTags = baseSku?.tags ?? []
    // --BST--
    this._productService.isTrackStock = item?.trackStock ?? item?.isTrackInventory ?? false
    this._productService.isAllowNegativeStock = item?.allowNegativeStock ?? false
    const sellOnline = item?.sellOnline ?? item?.SellOnline ?? false
    this._productService.isSellOnline = sellOnline

    // item.sellOnline == true ? this._abd.selectedProductSellType = this._abd.productSellType[0] : this._abd.selectedProductSellType = this._abd.productSellType[1]
    sellOnline == true ? this._abd.selectedProductSellType = this._abd.productSellType[0] : this._abd.selectedProductSellType = this._abd.productSellType[1]
    // Auto PO
    this._productService.pts.autoPurchaseOrder = baseSku?.autoPurchaseOrder
    //  Auto PO
    //-- pricing
    this._productService.pts.priceA = baseSku?.salePriceA
    this._productService.pts.priceB = baseSku?.salePriceB
    this._productService.pts.priceC = baseSku?.salePriceC
    this._productService.pts.minLevel = baseSku?.minLevel
    this._productService.pts.maxLevel = baseSku?.maxLevel
    this._productService.pts.minOrderQty = baseSku?.minOrderQty
    // Auto PO
    this._productService.pts.maxOrderQty = baseSku?.maxOrderQty
    // Auto PO
    this._productService.pts.reorderLevel = baseSku?.reorderLevel

    this._productService.pts.costPrice = baseSku?.costPrice
    this._productService.pts.discountPrice = baseSku?.discountPrice

    temp = this.findProductInfoOption(this._productService.productInfo?.defaultPrice, baseSku?.defaultPrice ?? baseSku?.DefaultPrice)
    if (!temp) temp = this._productService.productInfo.defaultPrice?.[0]
    this._productService.selectedDefaultPrice = temp

    this._productService.isTaxable = item?.isTaxable ?? true
    this._productService.isOpenPrice = item?.isOpnDept ?? false // ??

    temp = this.findProductInfoOption(this._productService.productInfo?.taxRate, baseSku?.taxRateId ?? baseSku?.TaxRateId)
    if (!temp) temp = this._productService.productInfo.taxRate?.[0]
    // this._productService.selectedDefaultPrice = temp

    if (temp) {
      let s = JSON.parse(JSON.stringify(temp))
      s.name = s.name.replace(/\s\d+$/, '');
      const percentage = this._abd.systemConfigs.taxConfig.tax1;
      s.name = `${s.name} (${percentage}%)`;
      this._productService.taxRates = [s];
      this._productService.selectedTaxRate = s;
    } else {
      this._productService.taxRates = []
      this._productService.selectedTaxRate = null
    }

    temp = this.findProductInfoOption(this._productService.productInfo?.sellQuantity, baseSku?.sellQuantity ?? baseSku?.SellQuantity)
    if (!temp) temp = this._productService.productInfo.sellQuantity?.[0]
    this._productService.selectedSellQuantity = temp

    temp = this._abd.uom.find(f => f.id === baseSku?.uomId)
    if (!temp) temp = this._abd.uom?.[0]
    this._abd.selectedUom = temp
    this._productService.pts.caseQty = baseSku?.caseQty ?? 1

    //-- product notes
    this._productService.productNotes = item.notes
    this._productService.printNotesOnReceipt = item.printOnInvoice
    this._productService.ShowNotesWhenRingingItem = item.showNotesWhen

    //-- general
    const activeDepartments = this._abd.initActDepartments() ?? []
    const activeCategories = this._abd.initActCategories() ?? []
    const activeManufacturers = this._abd.initActManufacturers() ?? []
    const activeVendors = this._abd.initActVendors() ?? []

    this._abd.selectedDepartment = this.findOptionById(
      activeDepartments,
      item?.departmentId,
      item?.DepartmentId
    )
    this._abd.selectedCategory = this.findOptionById(
      activeCategories,
      item?.categoryId,
      item?.CategoryId
    )
    this._abd.selectedManufacturer = this.findOptionById(
      activeManufacturers,
      item?.manufacturerId,
      item?.ManufacturerId
    )
    this._abd.selectedVendor = this.findOptionById(
      activeVendors,
      item?.vendorId,
      item?.VendorId
    )

    //----- shipping information
    const shipping = baseSku?.shippingDimention ?? baseSku?.shippingDimension ?? {};
    temp = this._abd.WeightUOM.find(f => f.id == shipping.weightUOM)
    if (!temp) temp = this._abd.WeightUOM?.[0]
    this._productService.selectedShippingWeight = temp
    this._productService.shippingWeight = shipping?.weight ?? 0

    temp = this._abd.DimensionUOM.find(f => f.id == shipping.dimensionUOM)
    if (!temp) temp = this._abd.DimensionUOM?.[0]
    this._productService.selectedShippingDimension = temp
    this._productService.shippingHeight = shipping?.height ?? 0
    this._productService.shippingWidth = shipping?.width ?? 0
    this._productService.shippingLength = shipping?.length ?? 0

    //----- shipping information
    const productSellType = item?.productSellType ?? item?.ProductSellType
    if (productSellType == 'online') this._abd.selectedProductSellType = this._abd.productSellType[0]
    if (productSellType == 'offline') this._abd.selectedProductSellType = this._abd.productSellType[1]
    if (productSellType == 'all') this._abd.selectedProductSellType = this._abd.productSellType[2]

    // this._globals.sleep(1000).then(() => {
    //   // const eee = this.getBase64Image(document.getElementById("imageid"), item.image)
    // })
    setTimeout(() => {
      this.updatemetaDetails();
    }, 500);
  }

  private getPrimarySkuFromList(list: any[]): any | null {
    if (!Array.isArray(list) || list.length < 1) return null;
    const def = list.find((sku) => sku?.isDefault ?? sku?.IsDefault);
    return def ?? list[0];
  }

  private findProductInfoOption(options: any[], rawValue: any): any | null {
    if (!Array.isArray(options) || rawValue === undefined || rawValue === null) {
      return null;
    }

    const normalize = (value: any) => String(value ?? '').trim().toLowerCase();
    const target = normalize(rawValue);
    if (!target) {
      return null;
    }

    return options.find((option) => {
      const candidates = [
        option?.value,
        option?.Value,
        option?.id,
        option?.Id,
        option?.name,
        option?.Name,
        option?.label,
        option?.Label,
        option?.type,
        option?.Type
      ];

      return candidates.some((candidate) => normalize(candidate) === target);
    }) ?? null;
  }

  private toSafeNumber(value: any): number {
    const parsed = typeof value === 'number' ? value : Number(String(value ?? '').trim());
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private normalizeId(value: any): string {
    if (value === undefined || value === null) return '';
    return String(value).trim().toLowerCase();
  }

  private idsMatch(left: any, right: any): boolean {
    const a = this.normalizeId(left);
    const b = this.normalizeId(right);
    return !!a && !!b && a === b;
  }

  private findOptionById(options: any[], ...candidateIds: any[]): any | null {
    if (!Array.isArray(options) || options.length < 1) return null;

    const normalizedCandidates = candidateIds
      .map((id) => this.normalizeId(id))
      .filter((id) => !!id);

    if (normalizedCandidates.length < 1) return null;

    return (
      options.find((option) =>
        normalizedCandidates.some((candidate) => this.idsMatch(option?.id, candidate))
      ) ?? null
    );
  }

  private getNormalizedLocationKey(value: any): string {
    if (value === undefined || value === null) return '';
    return String(value).trim();
  }

  private resolveLocationIdentifier(location: any): any {
    if (!location) return null;
    return (
      location.locationId
      ?? location.LocationId
      ?? location.locationID
      ?? location.LocationID
      ?? location.id
      ?? location.Id
      ?? null
    );
  }

  private getVariantStockKeyBySkuCode(skuCode: any): string {
    const raw = String(skuCode ?? '').trim();
    if (!raw) return '';
    if (/^\d+$/.test(raw)) {
      const normalized = raw.replace(/^0+/, '') || '0';
      return `sku:${normalized}`;
    }
    return `sku:${raw.toLowerCase()}`;
  }

  private getVariantStockKeyBySkuId(skuId: any): string {
    if (skuId === undefined || skuId === null || String(skuId).trim() === '') return '';
    return `skuid:${String(skuId).trim().toLowerCase()}`;
  }

  private getVariantLabelFromOptions(options: Record<string, any> | undefined | null): string {
    if (!options) return '';
    return Object.values(options)
      .map((value) => String(value ?? '').trim())
      .filter((value) => !!value)
      .join(' / ');
  }

  private getVariantStockKeyByLabel(label: any): string {
    const value = String(label ?? '')
      .trim()
      .toLowerCase();
    return value ? `variant:${value}` : '';
  }

  private getLegacyVariantStockKeyByLabel(label: any): string {
    const value = String(label ?? '')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase();
    return value ? `vlabel:${value}` : '';
  }

  private getVariantOpeningStockForLocation(
    variantStocks: Record<string, Record<string, number>>,
    locationId: any,
    row: { id?: string; sku?: string; skuId?: string | number | null; options?: Record<string, string>; available?: number | null }
  ): number | null {
    const locationKey = this.getNormalizedLocationKey(locationId);
    if (!locationKey) return null;

    const stockBucket = variantStocks?.[locationKey];
    if (!stockBucket) return null;

    const byRowId = row?.id ? stockBucket[row.id] : undefined;
    if (byRowId !== undefined && byRowId !== null) return this.toSafeNumber(byRowId);

    const bySku = stockBucket[this.getVariantStockKeyBySkuCode(row?.sku)];
    if (bySku !== undefined && bySku !== null) return this.toSafeNumber(bySku);

    const bySkuId = stockBucket[this.getVariantStockKeyBySkuId(row?.skuId)];
    if (bySkuId !== undefined && bySkuId !== null) return this.toSafeNumber(bySkuId);

    const byLabel = stockBucket[this.getVariantStockKeyByLabel(this.getVariantLabelFromOptions(row?.options))];
    if (byLabel !== undefined && byLabel !== null) return this.toSafeNumber(byLabel);

    const byLegacyLabel = stockBucket[this.getLegacyVariantStockKeyByLabel(this.getVariantLabelFromOptions(row?.options))];
    if (byLegacyLabel !== undefined && byLegacyLabel !== null) return this.toSafeNumber(byLegacyLabel);

    return null;
  }

  private hasValue(value: any): boolean {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  private getOpeningQuantityFromStockDetail(detail: any): number {
    if (this.hasValue(detail?.openingStock)) {
      return this.toSafeNumber(detail?.openingStock);
    }
    if (this.hasValue(detail?.stockOnHands)) {
      return this.toSafeNumber(detail?.stockOnHands);
    }
    return 0;
  }

  private buildVariantQtyBySkuCode(openingStocks: any[], itemSkus: any[]): Map<string, number> {
    const qtyBySkuCode = new Map<string, number>();

    if (Array.isArray(openingStocks)) {
      openingStocks.forEach((stock) => {
        const skuCode = String(stock?.skuCode ?? stock?.SkuCode ?? '').trim();
        if (!skuCode) return;
        const qty = this.toSafeNumber(stock?.quantity ?? stock?.Quantity);
        qtyBySkuCode.set(skuCode, (qtyBySkuCode.get(skuCode) || 0) + qty);
      });
    }

    if (qtyBySkuCode.size > 0 || !Array.isArray(itemSkus)) {
      return qtyBySkuCode;
    }

    itemSkus.forEach((sku) => {
      const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim();
      if (!skuCode) return;

      let totalQty = 0;
      const stockDetails = Array.isArray(sku?.stockDetails) ? sku.stockDetails : [];
      if (stockDetails.length) {
        stockDetails.forEach((detail) => {
          totalQty += this.getOpeningQuantityFromStockDetail(detail);
        });
      } else if (this.hasValue(sku?.totalOpeningStock ?? sku?.TotalOpeningStock)) {
        totalQty = this.toSafeNumber(sku?.totalOpeningStock ?? sku?.TotalOpeningStock);
      } else if (this.hasValue(sku?.totalStockOnHands ?? sku?.TotalStockOnHands)) {
        totalQty = this.toSafeNumber(sku?.totalStockOnHands ?? sku?.TotalStockOnHands);
      }

      qtyBySkuCode.set(skuCode, totalQty);
    });

    return qtyBySkuCode;
  }

  private getVariantQuantityForSku(sku: any, openingStocks: any[]): number {
    const stockDetails = Array.isArray(sku?.stockDetails) ? sku.stockDetails : [];
    if (stockDetails.length) {
      return stockDetails.reduce((sum: number, detail: any) => sum + this.getOpeningQuantityFromStockDetail(detail), 0);
    }

    if (this.hasValue(sku?.totalOpeningStock ?? sku?.TotalOpeningStock)) {
      return this.toSafeNumber(sku?.totalOpeningStock ?? sku?.TotalOpeningStock);
    }

    if (this.hasValue(sku?.totalStockOnHands ?? sku?.TotalStockOnHands)) {
      return this.toSafeNumber(sku?.totalStockOnHands ?? sku?.TotalStockOnHands);
    }

    const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim();
    if (!skuCode || !Array.isArray(openingStocks)) {
      return 0;
    }

    let total = 0;
    openingStocks.forEach((stock) => {
      const stockSkuCode = String(stock?.skuCode ?? stock?.SkuCode ?? '').trim();
      if (stockSkuCode !== skuCode) return;
      total += this.toSafeNumber(stock?.quantity ?? stock?.Quantity);
    });
    return total;
  }

  private extractSkuShippingFields(sku: any): {
    shippingWeight: number | null;
    shippingHeight: number | null;
    shippingWidth: number | null;
    shippingLength: number | null;
    shippingDimensionUOM: number | string | null;
  } {
    const shipping = sku?.shippingDimention ?? sku?.shippingDimension ?? {};
    return {
      shippingWeight: shipping?.weight ?? null,
      shippingHeight: shipping?.height ?? null,
      shippingWidth: shipping?.width ?? null,
      shippingLength: shipping?.length ?? null,
      shippingDimensionUOM: shipping?.dimensionUOM ?? null,
    };
  }

  private buildVariantLocationStocks(
    rowIdBySkuId: Map<string, string>,
    rowIdBySkuCode: Map<string, string>,
    openingStocks: any[],
    itemSkus: any[]
  ): Record<string, Record<string, number>> {
    const locationStocks: Record<string, Record<string, number>> = {};

    if (Array.isArray(openingStocks)) {
      openingStocks.forEach((stock) => {
        const locationId = stock?.locationId ?? stock?.LocationId ?? stock?.locationID ?? stock?.LocationID;
        const locationKey = this.getNormalizedLocationKey(locationId);
        const skuCode = String(stock?.skuCode ?? stock?.SkuCode ?? '').trim();
        if (!locationKey || !skuCode) return;
        const rowId = rowIdBySkuCode.get(skuCode);
        if (!rowId) return;
        if (!locationStocks[locationKey]) {
          locationStocks[locationKey] = {};
        }
        const quantity = this.toSafeNumber(stock?.quantity ?? stock?.Quantity);
        locationStocks[locationKey][rowId] = quantity;
        const skuKey = this.getVariantStockKeyBySkuCode(skuCode);
        if (skuKey) {
          locationStocks[locationKey][skuKey] = quantity;
        }
      });
    }

    if (!Array.isArray(itemSkus)) {
      return locationStocks;
    }

    const variantRows = Array.isArray(this._productService.variantRows) ? this._productService.variantRows : [];

    itemSkus.forEach((sku, index) => {
      const skuId = sku?.Id ?? sku?.id ?? sku?.itemSKUId ?? sku?.itemSkuId;
      const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim();
      const rowId =
        rowIdBySkuId.get(String(skuId ?? '').trim()) ||
        rowIdBySkuCode.get(skuCode) ||
        (variantRows.length === itemSkus.length ? String(variantRows[index]?.id ?? '').trim() : '');
      if (!rowId) return;

      const stockDetails = Array.isArray(sku?.stockDetails) ? sku.stockDetails : [];
      stockDetails.forEach((detail) => {
        const locationId = detail?.locationId ?? detail?.LocationId ?? detail?.locationID ?? detail?.LocationID;
        const locationKey = this.getNormalizedLocationKey(locationId);
        if (!locationKey) return;

        const qty = this.getOpeningQuantityFromStockDetail(detail);
        if (!locationStocks[locationKey]) {
          locationStocks[locationKey] = {};
        }

        if (locationStocks[locationKey][rowId] === undefined) {
          locationStocks[locationKey][rowId] = qty;
        }
        const skuKey = this.getVariantStockKeyBySkuCode(skuCode);
        if (skuKey && locationStocks[locationKey][skuKey] === undefined) {
          locationStocks[locationKey][skuKey] = qty;
        }
        const skuIdKey = this.getVariantStockKeyBySkuId(skuId);
        if (skuIdKey && locationStocks[locationKey][skuIdKey] === undefined) {
          locationStocks[locationKey][skuIdKey] = qty;
        }
        const variantLabelKey = this.getVariantStockKeyByLabel(
          sku?.variantLabel ?? sku?.VariantLabel ?? this.extractVariantValuesFromSkuTitle(sku, '', 0).join(' / ')
        );
        if (variantLabelKey && locationStocks[locationKey][variantLabelKey] === undefined) {
          locationStocks[locationKey][variantLabelKey] = qty;
        }
      });
    });

    return locationStocks;
  }

  private toOpeningStockNumber(value: any): number {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private getOpeningStockKey(locationId: any, skuCode: any): string {
    const locationKey = String(locationId ?? '').trim().toLowerCase();
    const skuKey = String(skuCode ?? '').trim().toLowerCase();
    if (!locationKey || !skuKey) {
      return '';
    }
    return `${locationKey}|${skuKey}`;
  }

  private buildOpeningStockChangePayload(openingStocks: any[]): any[] {
    const nextStocks = Array.isArray(openingStocks) ? openingStocks : [];
    const timestamp = new Date().toISOString();

    if (this._productService.isNew) {
      return nextStocks.map((stock) => ({
        ...stock,
        IsChanged: true,
        isChanged: true,
        changeType: 'added',
        updateTime: timestamp,
        updatedAt: timestamp
      }));
    }

    const previousRaw =
      this._productService.activeItem?.OpeningStocks
      ?? this._productService.activeItem?.openingStocks
      ?? [];
    const previousStocks = Array.isArray(previousRaw) ? previousRaw : [];
    const previousByKey = new Map<string, any>();

    previousStocks.forEach((stock) => {
      const key = this.getOpeningStockKey(
        stock?.locationId ?? stock?.LocationId,
        stock?.skuCode ?? stock?.SkuCode
      );
      if (key) {
        previousByKey.set(key, stock);
      }
    });

    const processedKeys = new Set<string>();
    const payload: any[] = [];

    nextStocks.forEach((stock) => {
      const key = this.getOpeningStockKey(stock?.locationId, stock?.skuCode);
      const previous = key ? previousByKey.get(key) : null;
      const previousQty = this.toOpeningStockNumber(previous?.quantity ?? previous?.Quantity);
      const nextQty = this.toOpeningStockNumber(stock?.quantity ?? stock?.Quantity);
      const isAdded = !previous;
      const isUpdated = !!previous && previousQty !== nextQty;
      const isChanged = isAdded || isUpdated;
      const existingUpdateTime =
        stock?.updateTime
        ?? stock?.updatedAt
        ?? previous?.updateTime
        ?? previous?.updatedAt
        ?? null;

      payload.push({
        ...stock,
        IsChanged: isChanged,
        isChanged: isChanged,
        changeType: isAdded ? 'added' : (isUpdated ? 'updated' : 'unchanged'),
        previousQuantity: previousQty,
        updateTime: isChanged ? timestamp : existingUpdateTime,
        updatedAt: isChanged ? timestamp : existingUpdateTime
      });

      if (key) {
        processedKeys.add(key);
      }
    });

    previousByKey.forEach((previous, key) => {
      if (processedKeys.has(key)) {
        return;
      }

      payload.push({
        ...previous,
        locationId: previous?.locationId ?? previous?.LocationId,
        skuCode: previous?.skuCode ?? previous?.SkuCode,
        quantity: 0,
        IsChanged: true,
        isChanged: true,
        isRemoved: true,
        removed: true,
        isDeleted: true,
        changeType: 'removed',
        previousQuantity: this.toOpeningStockNumber(previous?.quantity ?? previous?.Quantity),
        updateTime: timestamp,
        updatedAt: timestamp
      });
    });

    return payload;
  }

  private getItemSkuList(item: any): any[] {
    const candidates = [
      item?.ItemSKUs,
      item?.itemSKUs,
      item?.crsItemSKUs,
      item?.CrsItemSKUs,
      item?.SKUs,
      item?.SkUs,
      item?.skUs,
      item?.skus,
      item?.itemSKURanges,
      item?.skuRanges,
      item?.variants,
      item?.Variants
    ]
    for (const entry of candidates) {
      if (Array.isArray(entry) && entry.length) {
        return entry
      }
    }
    return []
  }

  private collectVariantValuesFromSkus(
    itemSkus: any[],
    itemName: string,
    optionNames: string[]
  ): Map<string, Set<string>> {
    const map = new Map<string, Set<string>>();
    optionNames.forEach((name) => map.set(name, new Set<string>()));
    const expectedCount = optionNames.length;
    if (!Array.isArray(itemSkus) || !expectedCount) return map;

    itemSkus.forEach((sku) => {
      const parts = this.extractVariantValuesFromSkuTitle(sku, itemName, expectedCount);
      if (!parts.length) return;
      parts.forEach((value, idx) => {
        const name = optionNames[idx];
        if (!name) return;
        map.get(name)?.add(value);
      });
    });

    for (const [key, set] of map.entries()) {
      if (!set.size) {
        map.delete(key);
      }
    }
    return map;
  }

  private extractVariantValuesFromSkuTitle(
    sku: any,
    itemName: string,
    expectedCount: number
  ): string[] {
    const title = String(sku?.title ?? sku?.Title ?? sku?.name ?? sku?.Name ?? '').trim();
    if (!title || !expectedCount) return [];
    let label = title;
    const baseName = String(itemName ?? '').trim();
    if (baseName && title.toLowerCase().startsWith(baseName.toLowerCase())) {
      label = title.slice(baseName.length).trim();
      if (label.startsWith('-')) label = label.slice(1).trim();
    }
    if (label.includes(' - ')) {
      const pieces = label.split(' - ');
      label = pieces[pieces.length - 1].trim();
    }
    const parts = label
      .split('/')
      .map((part) => part.trim())
      .filter((part) => part.length > 0);
    if (parts.length !== expectedCount) return [];
    return parts;
  }

  private isColorOptionName(optionName: string): boolean {
    const normalized = String(optionName || '').trim().toLowerCase()
    return normalized === 'color' || normalized === 'colour' || normalized.includes('color') || normalized.includes('colour')
  }

  private normalizeHexValue(value: any): string | null {
    const hex = String(value ?? '').trim()
    if (!hex) return null
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex) ? hex : null
  }

  private getVariantOptionStorageValue(optionName: string, displayValue: string): string {
    const normalizedDisplay = String(displayValue ?? '').trim()
    if (!normalizedDisplay) return ''
    if (!this.isColorOptionName(optionName)) return normalizedDisplay
    const normalizedOptionName = String(optionName || '').trim().toLowerCase()
    const option = Array.isArray(this._productService.variantAttributes)
      ? this._productService.variantAttributes.find((entry: any) =>
          String(entry?.name ?? entry?.Name ?? '').trim().toLowerCase() === normalizedOptionName)
      : null
    const mappedHex = option?.colorValueMap?.[normalizedDisplay] ?? option?.ColorValueMap?.[normalizedDisplay]
    const normalizedMappedHex = this.normalizeHexValue(mappedHex)
    if (normalizedMappedHex) return normalizedMappedHex
    const explicitHex = this.normalizeHexValue(normalizedDisplay)
    if (explicitHex) return explicitHex
    return this.colorHexByName[normalizedDisplay.toLowerCase()] ?? normalizedDisplay
  }

  getBase64Image(img, url) {
    var image = new Image()
    image.setAttribute('crossorigin', 'anonymous');
    image.src = url
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0);
    var dataURL = canvas.toDataURL("image/jpg");
    return dataURL.replace(/^data:image\/(png|jpg|jpeg|pdf|webp);base64,/, "");
  }

  restAllFields() {
    this._productService.activeItem = null
    this._productService.useParentSkuBarcodeForVariants = false

    const productInfo = this._productService.productInfo || {};
    const defaultPrice = productInfo.defaultPrice?.[0] ?? null;
    const taxRateBase = productInfo.taxRate?.[0] ?? null;
    const sellQuantity = productInfo.sellQuantity?.[0] ?? null;

    this.tempImageUrl = ''
    this._productService.featureImage = null
    this._productService.thImages = []
    this._productService.thImageNames = []
    this._productService.pts.t_productName = ''
    this._productService.isPrintAsQR = false
    this._productService.productDescription = ''

    this._productService.selectedLocations = []

    this._productService.selectedProductType = productInfo.itemType?.[0] ?? null
    this._productService.selectedSellAs = productInfo.sellAs?.[1] ?? productInfo.sellAs?.[0] ?? null
    this._productService.selectedGrouping = productInfo.grouping?.[0] ?? null
    this._productService.selectedDiscount = productInfo.discount?.[0] ?? null
    this._productService.selectedAgeRestriction = productInfo.ageRestriction?.[0] ?? null
    this._productService.selectedGender = productInfo.gender?.[0] ?? null
    //-- inventory
    this._productService.pts.sku = ''
    this._productService.pts.barcode = ''

    // --BST--
    this._productService.pts.itemSKUId = ""
    this._productService.pts.altBarcode = []
    this._productService.pts.altSKUs = []
    this._productService.pts.altTags = []

    // --BST--
    this._productService.isTrackStock = false
    this._productService.isAllowNegativeStock = false
    this._productService.isSellOnline = false

    //-- pricing
    this._productService.pts.priceA = ''
    this._productService.pts.priceB = ''
    this._productService.pts.priceC = ''

    this._productService.pts.costPrice = ''
    this._productService.pts.discountPrice = ''

    this._productService.selectedDefaultPrice = defaultPrice

    this._productService.isTaxable = false
    this._productService.isOpenPrice = false

    if (taxRateBase) {
      const s = { ...taxRateBase };
      const percentage = this._abd.systemConfigs?.taxConfig?.tax1;
      if (percentage !== undefined && percentage !== null) {
        s.name = `${s.name} (${percentage}%)`;
      }
      this._productService.taxRates = [s];
      this._productService.selectedTaxRate = s;
    } else {
      this._productService.taxRates = [];
      this._productService.selectedTaxRate = null;
    }

    this._productService.selectedSellQuantity = sellQuantity
    this._abd.selectedUom = this._abd.uom?.[0] ?? null
    this._productService.pts.caseQty = ''
    this._productService.variantAttributes = []
    this._productService.variantRows = []
    this._productService.variantLocationStocks = {}
    this._productService.variantLocationQohStocks = {}


    //-- product notes
    this._productService.productNotes = ''
    this._productService.printNotesOnReceipt = false
    this._productService.ShowNotesWhenRingingItem = false

    //-- general
    this.getInitData()

    //----- shipping information
    this._productService.selectedShippingWeight = this._abd.WeightUOM?.[0] ?? null
    this._productService.shippingWeight = 0

    this._productService.selectedShippingDimension = this._abd.DimensionUOM?.[3] ?? this._abd.DimensionUOM?.[0] ?? null
    this._productService.shippingHeight = 0
    this._productService.shippingWidth = 0
    this._productService.shippingLength = 0
  }

  prepareNewItem() {
    this._productService.isNew = true
    this._productService.isEdit = false
    this._productService.isViewOnly = false
    this._productService.useParentSkuBarcodeForVariants = false

    let sku: any = <any>this._globals.generateSKU() * 1
    this._productService.pts.sku = this._globals.generateSKU()
    this._productService.pts.barcode = this._globals.generateSKU()
    this._productService.pts.barcode = (sku + 23) + ''

    const defaultPrice = this._productService.productInfo?.defaultPrice?.[0] ?? null
    this._productService.selectedDefaultPrice = defaultPrice
    this._abd.selectedUom = this._abd.uom?.find?.(f => f.unitName === 'Each') ?? this._abd.uom?.[0] ?? null

    try {
      this._productService.productNotes = ''
      this.getInitData()
      this.activeItem = this.items[0]
      // this._productService.locations = JSON.parse(JSON.stringify(this._abd.actLocations))

      if (Array.isArray(this._productService.locations)) {
        for (let i = 0; i < this._productService.locations.length; i++)
          this._productService.locations[i].openingQty = 0

        this._productService.selectedLocations = []
        if (this._productService.locations[0]) {
          this._productService.selectedLocations.push(this._productService.locations[0])
        }
      }

      this._productService.pts.descriptionUrl = ''
      this._productService.labelPrintingImage = "";
    }
    catch {

      this._abd.loadInit().subscribe(res => {
        if (res.success) {
          this.getInitData()
          this.activeItem = this.items[0]
          this._productService.locations = JSON.parse(JSON.stringify(this._abd.locations))

          if (Array.isArray(this._productService.locations)) {
            for (let i = 0; i < this._productService.locations.length; i++)
              this._productService.locations[i].openingQty = 0

            this._productService.selectedLocations = []
            if (this._productService.locations[0]) {
              this._productService.selectedLocations.push(this._productService.locations[0])
            }
          }
        }
      })
    }
  }
  initForm() {
    this.labelForm = this._fb.group({
      location: ['', Validators.required],
      locations: ['', Validators.required],
      noOfCopy: ['', [Validators.required, Validators.maxLength(6), Validators.pattern(/^([0-9]\d*)(\.\d+)?$/)]],
    })
    this.tagsForm = this._fb.group({
      altBarcodes: [{ value: [], disabled: this._productService.isViewOnly }],
      altSKUs: [{ value: [], disabled: this._productService.isViewOnly }],
      altTags: [{ value: [], disabled: this._productService.isViewOnly }],
    })
    this.changeEvent()
  }
  updatemetaDetails() {
    this.tagsForm.get('altBarcodes')?.setValue(this._productService.pts?.altBarcode)
    this.tagsForm.get('altSKUs')?.setValue(this._productService.pts?.altSKUs)
    this.tagsForm.get('altTags')?.setValue(this._productService.pts?.altTags)
  }
  changeEvent() {
    this.tF.altBarcodes.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altBarcodes.value, this.tF.altBarcodes)
    })
    this.tF.altSKUs.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altSKUs.value, this.tF.altSKUs)
    })
    this.tF.altTags.valueChanges.subscribe((v) => {
      this.findDuplicates(this.tF.altTags.value, this.tF.altTags)
    })

  }
  findDuplicates(arr: any[], input) {
    const seen = new Set();
    const duplicates = new Set();

    for (const value of arr) {
      if (seen.has(value)) {
        duplicates.add(value);
      } else {
        seen.add(value);
      }
    }
    if (Array.from(duplicates).length > 0) {
      input?.setErrors({ duplicates: true });
      // this.alreadyExistBarcodes = Array.from(duplicates).join(', ')
    }
    // else{
    //   input?.setErrors(null);
    //   input?.updateValueAndValidity();;
    //   // this.alreadyExistBarcodes = ''
    // }
  }
  get f() {
    return this.labelForm.controls;
  }
  get tF() {
    return this.tagsForm.controls;
  }

  //   activeTemplate(id){
  //     this.activeTemplateId = id; 
  // }
  getInitData() {
    this._abd.selectedDepartment = this._abd.initActDepartments()[0]
    this._abd.selectedCategory = this._abd.initActCategories()[0]
    this._abd.selectedManufacturer = this._abd.initActManufacturers()[0]
    this._abd.selectedVendor = this._abd.initActVendors()[0]
  }

  private refreshUomData(): void {
    if (!Array.isArray(this._abd.uom) || this._abd.uom.length === 0) return

    const sellAsValue =
      this._productService.selectedSellAs?.value ??
      this._productService.productInfo?.sellAs?.[0]?.value ??
      null

    let baseList: any[] = []
    if (sellAsValue !== null && sellAsValue !== undefined) {
      baseList = this._abd.uom.filter(f => f.unitClassId === sellAsValue)
    } else if (Array.isArray(this._abd.uomCalc) && this._abd.uomCalc.length) {
      baseList = [...this._abd.uomCalc]
    } else {
      baseList = [...this._abd.uom]
    }

    const allowedNames = new Set(['each', 'box'])
    const allowedList = baseList.filter(
      f => allowedNames.has(String(f?.unitName || '').toLowerCase())
    )
    this._abd.uomCalc = allowedList.length ? allowedList : baseList

    const selectedId = this._abd.selectedUom?.id
    const isSelectedValid =
      selectedId !== undefined &&
      selectedId !== null &&
      this._abd.uomCalc.some(f => f.id === selectedId)

    if (!isSelectedValid) {
      this._abd.selectedUom =
        this._abd.uomCalc.find(f => String(f?.unitName || '').toLowerCase() === 'each') ??
        this._abd.uomCalc.find(f => String(f?.unitName || '').toLowerCase() === 'box') ??
        this._abd.uomCalc[0] ??
        null
    }
  }

  onTabItemClick(tab: any) {
    // console.log()
    //   if(this.activeItem.label === 'Stock Management'){
    //     this._confirmationService.confirm({
    //       header: `Confirmation?`,
    //       message: `Changes you made will be lost. Are you sure you want to proceed?`,
    //       accept: () => {
    //     // Start 
    //       this.activeItem = tab.activeItem  
    //     // End
    //       }
    //     });
    //   }else{
    this.activeItem = tab.activeItem
    // }        
  }

  onInventoryTabClose(): void {
    const form = this.__productInventory?.editform;
    if (form && this.hasInventoryRequiredErrors(form)) {
      form.markAllAsTouched();
      this.inventorySectionError = true;
      this._connMessageService.showToastMessage('Inventory section has required fields. Please expand to fix them.', 'error');
    } else {
      this.inventorySectionError = false;
    }
    this.updateAdditionalDetailsError();
  }

  onInventoryTabOpen(): void {
    this.inventorySectionError = false;
    this.updateAdditionalDetailsError();
  }

  onPricingTabClose(): void {
    const form = this.__productPricing?.editform;
    if (form && form.invalid) {
      form.markAllAsTouched();
    }
    this.updateAdditionalDetailsError();
  }

  onPricingTabOpen(): void {
    this.updateAdditionalDetailsError();
  }

  onAdditionalDetailsClose(): void {
    this.updateAdditionalDetailsError();
  }

  onAdditionalDetailsOpen(): void {
    this.updateAdditionalDetailsError();
  }

  private updateAdditionalDetailsError(): void {
    const inventoryInvalid = this.hasInventoryRequiredErrors(this.__productInventory?.editform) || this.inventorySectionError;
    const pricingInvalid = this.hasPricingRequiredErrors(this.__productPricing?.editform);
    this.additionalDetailsError = !!(inventoryInvalid || pricingInvalid);
  }

  private subscribeToSectionValidity(): void {
    const inventoryForm = this.__productInventory?.editform;
    if (inventoryForm) {
      inventoryForm.statusChanges.subscribe(() => this.updateAdditionalDetailsError());
    }

    const pricingForm = this.__productPricing?.editform;
    if (pricingForm) {
      pricingForm.statusChanges.subscribe(() => this.updateAdditionalDetailsError());
    }
  }

  accordion_b_toggle(index: number) {
    this.activeStateB[index] = !this.activeStateB[index] ? false : true
  }

  get hasAdditionalDetailsError(): boolean {
    return this.additionalDetailsError;
  }

  private hasTouchedInvalid(control?: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  private hasInventoryRequiredErrors(form?: FormGroup): boolean {
    if (!form) return false;
    return this.hasTouchedInvalid(form.get('sku')) || this.hasTouchedInvalid(form.get('barcode'));
  }

  private hasPricingRequiredErrors(form?: FormGroup): boolean {
    if (!form) return false;
    return this.hasTouchedInvalid(form.get('priceA')) || this.hasTouchedInvalid(form.get('costPrice'));
  }

  newDepartClick() {
    this._departmentService.activeItem.departmentName = ''
    this._productService.isNewDepartment = true
  }

  addCategory(): void {
    this._productService.isNewCategory = true;
  }

  departmentChanged(e) {
    const selectedDepartmentId = e?.value?.id;
    this._abd.actCategories = (this._abd.categories ?? []).filter(
      f => this.idsMatch(f?.departmentId, selectedDepartmentId)
    )

    if (this._abd.actCategories.length > 0)
      this._abd.selectedCategory = this._abd.actCategories[0]
    else
      this._abd.selectedCategory = null
  }

  onSellChipsChange(values: string[]): void {
    this.selectedSellChips = values;
    this.updateSellFlagsFromChips();
  }

  get isSaveDisabled(): boolean {
    return this._productService.isViewOnly || !this.validToSave();
  }

  onQuickPriceChange(value: string | number): void {
    const normalized = this.formatToTwoDecimals(value);
    this._productService.pts.priceA = normalized;
    const priceControl = this.__productPricing?.editform?.get('priceA');
    if (priceControl) {
      priceControl.setValue(normalized);
    }
  }

  onQuickPriceBlur(): void {
    const current = this._productService.pts.priceA;
    if (current === '' || current === null || current === undefined) {
      const normalized = this.formatToTwoDecimals(0);
      this._productService.pts.priceA = normalized;
      const priceControl = this.__productPricing?.editform?.get('priceA');
      if (priceControl) {
        priceControl.setValue(normalized);
      }
    }
  }

  onQuickCostChange(value: string | number): void {
    const normalized = this.formatToTwoDecimals(value);
    this._productService.pts.costPrice = normalized;
    const costControl = this.__productPricing?.editform?.get('costPrice');
    if (costControl) {
      costControl.setValue(normalized);
    }
  }

  onQuickCostBlur(): void {
    const current = this._productService.pts.costPrice;
    if (current === '' || current === null || current === undefined) {
      const normalized = this.formatToTwoDecimals(0);
      this._productService.pts.costPrice = normalized;
      const costControl = this.__productPricing?.editform?.get('costPrice');
      if (costControl) {
        costControl.setValue(normalized);
      }
    }
  }

  onZeroValueFocus(controlName: 'priceA' | 'costPrice', event: FocusEvent): void {
    const input = event?.target as HTMLInputElement | null;
    if (!input) return;
    const rawValue = (input.value || '').trim();
    if (!this.isZeroDisplayValue(rawValue)) return;
    if (this._productService?.pts && controlName in this._productService.pts) {
      this._productService.pts[controlName] = null;
    }
    const control = this.__productPricing?.editform?.get(controlName);
    if (control) {
      control.setValue(null);
    }
    setTimeout(() => {
      try {
        input.setSelectionRange(0, 0);
      } catch { }
    }, 0);
  }

  private isZeroDisplayValue(value: string): boolean {
    const normalized = value.replace(/[^0-9.-]/g, '');
    if (!normalized) return false;
    const numericValue = Number(normalized);
    return !isNaN(numericValue) && numericValue === 0;
  }

  onCategoryChanged(event: any): void {
    this._abd.selectedCategory = event?.value || event;
  }

  /** Dropdown groups: the business's own categories, then the industry's suggestions it does not have yet. */
  private buildCategoryOptions(categories: any[]): any[] {
    const owned = categories ?? [];
    const suggested = suggestedCategories(
      this._globals.userInfo?.businessSetup?.[0]?.industry,
      owned.map((category) => category.categoryName)
    ).map((category) => ({ categoryName: category.name, parent: category.parent, isSuggestion: true }));

    return [
      { label: 'Your categories', items: owned },
      { label: 'Suggested for your business', items: suggested }
    ].filter((group) => group.items.length > 0);
  }

  /** Creates the picked suggestion as a category on product save and selects the saved one; resolves false when that fails. */
  private async createSuggestedCategory(suggestion: any): Promise<boolean> {
    const department = this._abd.selectedDepartment || this._abd.initActDepartments()?.[0] || this._abd.departments?.[0] || null;
    // Same fallback as the setup checklist when the business has no department loaded.
    const departmentId = this._globals.userInfo?.businessSetup?.[0]?.departmentId || department?.id || 1;

    let keepSpinner = false;
    this._abd.showSpinner();
    try {
      const res: any = await firstValueFrom(this._catService.createUpdateCategory({
        id: null,
        categoryName: suggestion.categoryName,
        isActive: true,
        departmentId,
        image: ''
      }));
      if (!res?.success) {
        console.error('createSuggestedCategory: create failed', res);
        return false;
      }
      this._abd.showSpinner(); // the POST response hid it; keep it on until the product save takes over

      const created = res.data?.id != null ? res.data : null;
      // Same as the setup checklist: reload categories, then poll until the new one shows up.
      this._abd.getAllCategories();
      const name = suggestion.categoryName.toLowerCase();
      let saved: any = null;
      for (let attempt = 0; attempt < 8 && !saved; attempt++) {
        saved = (this._abd.categories ?? []).find((category) => category.categoryName?.toLowerCase() === name && category.id);
        if (!saved) await new Promise((resolve) => setTimeout(resolve, 300 * Math.pow(1.5, attempt)));
      }
      if (!saved && created) {
        // The reloaded list can lag the save, so keep the created category instead of falling back to the first one.
        saved = { ...created, departmentId: created.departmentId ?? departmentId, isActive: true };
        this._abd.categories = [...(this._abd.categories ?? []), saved];
      }
      this._abd.initCategories(this._abd.initActCategories());
      this._abd.selectedCategory = saved ?? null;
      keepSpinner = !!saved;
      // The category reload hid the spinner too; the product save hides it when it finishes.
      if (keepSpinner) this._abd.showSpinner();
      return keepSpinner;
    } catch (error) {
      console.error('createSuggestedCategory failed', error);
      return false;
    } finally {
      if (!keepSpinner) this._abd.hideSpinner();
    }
  }

  private syncSellChipSelection(): void {
    this.disabledSavedSellTypeLabel = null;

    if (!this.canSellOnline || !this.canSellInStore) {
      // Capture the product's own saved channel before it gets forced to the single
      // entitled one, so the template can tell the merchant what changed.
      if (!this._productService.isNew) {
        const savedType = this._abd.selectedProductSellType;
        const entitledId = this.canSellOnline ? 1 : (this.canSellInStore ? 2 : null);
        if (savedType?.id && entitledId && savedType.id !== entitledId) {
          this.disabledSavedSellTypeLabel = savedType.Type;
        }
      }
      this.applyPlanSellRestrictions();
      return;
    }

    const sellType = this._abd.selectedProductSellType?.id;

    if (sellType === 3) {
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    } else if (sellType === 1) {
      this.selectedSellChips = ['online'];
    } else if (sellType === 2) {
      this.selectedSellChips = ['offline'];
    } else {
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    }

    this.updateSellFlagsFromChips(false);
  }

  private updateSellFlagsFromChips(resetSelection = true): void {
    if (!this.canSellOnline || !this.canSellInStore) {
      this.applyPlanSellRestrictions();
      return;
    }

    const hasOnline = this.selectedSellChips.includes('online');
    const hasInStore = this.selectedSellChips.includes('offline');

    if (hasOnline && hasInStore) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 3) || this._abd.productSellType[0];
    } else if (hasOnline) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 1) || this._abd.productSellType[0];
    } else if (hasInStore) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 2) || this._abd.productSellType[1];
    } else if (resetSelection) {
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 3) || this._abd.productSellType[0];
      this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    }

    this._productService.isSellOnline = this._abd.selectedProductSellType.id === 1 || this._abd.selectedProductSellType.id === 3;
    if (this._productService.isSellOnline) {
      this._productService.isOpenPrice = false;
    }
  }

  // Pins "Where to Sell" to a single, non-editable channel when the merchant's plan only
  // entitles one of Online (standardOnlineStore) / In-store (hasPOS or hasPOSLite).
  private applyPlanSellRestrictions(): void {
    if (this.canSellOnline && !this.canSellInStore) {
      this.sellChipOptions = this.sellChipOptionsBase.filter((o) => o.value === 'online');
      this.selectedSellChips = ['online'];
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 1) || this._abd.productSellType[0];
      this._productService.isSellOnline = true;
      this._productService.isOpenPrice = false;
      return;
    }

    if (!this.canSellOnline && this.canSellInStore) {
      this.sellChipOptions = this.sellChipOptionsBase.filter((o) => o.value === 'offline');
      this.selectedSellChips = ['offline'];
      this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 2) || this._abd.productSellType[1];
      this._productService.isSellOnline = false;
      return;
    }

    // Neither entitlement present — fall back to both so the merchant isn't locked out entirely.
    this.sellChipOptions = [...this.sellChipOptionsBase];
    this.selectedSellChips = this.sellChipOptions.map((o) => o.value);
    this._abd.selectedProductSellType = this._abd.productSellType.find((p) => p.id === 3) || this._abd.productSellType[0];
    this._productService.isSellOnline = true;
  }

  private formatToTwoDecimals(value: string | number): number | '' {
    if (value === null || value === undefined || value === '') return '';
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return '';
    return parseFloat(num.toFixed(2));
  }

  private removeNoBannerClass(): void {
    const container = document.querySelector('.layout-main');
    container?.classList.remove('mt-4');
  }

  private populateImagesFromActiveItem(item: any): void {
    this._productService.featureImage = null;
    this._productService.featureImageIndex = null;
    this._productService.thImages = [];
    this._productService.thImageNames = [];
    this._productService.hasGalleryChanged = false;

    const itemPictures = item?.itemPictures || [];

    // Preserve gallery pictures
    itemPictures.forEach((pic: any) => {
      if (pic?.picture) {
        this._productService.thImages.push(pic.picture);
        this._productService.thImageNames.push(''); // placeholder to keep indexes aligned
      }
    });

    const flagged = itemPictures.find((p: any) => p?.isFeature)?.picture;
    let flaggedIndex = flagged ? this._productService.thImages.indexOf(flagged) : -1;
    if (flaggedIndex === -1 && this._productService.thImages.length) {
      flaggedIndex = 0;
    }

    if (flaggedIndex >= 0) {
      this._productService.featureImageIndex = flaggedIndex;
      this._productService.featureImage = this._productService.thImages[flaggedIndex];
    }
  }

  async saveProductClick(where2: any) {
    this.syncVariantRowsFromEditor()
    if (!this.validToSave()) return

    if (this._abd.selectedCategory?.isSuggestion) {
      const created = await this.createSuggestedCategory(this._abd.selectedCategory)
      if (!created) {
        this._connMessageService.showToastMessage('Could not save the selected category. Please try again.', 'error')
        return
      }
    }

    this.makeSaveObject(where2)
    // if (where2 == 'save-only')
    //   window.history.back()
    // else {
    if (where2 === 'save-and-duplicate') {
      this._productService.pts.sku = this._globals.generateSKU()
      this._productService.pts.barcode = this._globals.generateSKU()
      this._productService.pts.barcode = ((<any>(this._productService.pts.barcode) * 1) + 23) + ''

      this.__productInventory.editform.controls['sku'].setValue(this._productService.pts.sku)
      this.__productInventory.editform.controls['barcode'].setValue(this._productService.pts.barcode)
      this.__productInventory.editform.controls['maxLevel'].setValue(this._productService.pts.maxLevel)
      this.__productInventory.editform.controls['minLevel'].setValue(this._productService.pts.minLevel)
      this.__productInventory.editform.controls['reorderLevel'].setValue(this._productService.pts.reorderLevel)
      this.__productInventory.editform.controls['minOrderQty'].setValue(this._productService.pts.minOrderQty)
      // Auto PO
      this.__productInventory.editform.controls['maxOrderQty'].setValue(this._productService.pts.maxOrderQty)

      this.isNew = true
    }
    // }
    // }
  }

  deleteProductClick(): void {
    if (this._productService.isViewOnly || this._productService.isNew) return

    const activeItem = this._productService.activeItem
    const productId = activeItem?.id
    if (!productId) {
      this._connMessageService.showToastMessage('No product selected to delete.', 'error')
      return
    }

    const name = activeItem?.itemName || 'this product'
    this._confirmationService.confirm({
      header: `Delete Product: ${name}?`,
      message: 'Deleting process causes permanent loss of information. Are you sure to proceed?',
      icon: 'pi pi-info-circle',
      accept: () => {
        try {
          this._abd.showSpinner()
          this._productService.deleteProduct(productId).subscribe(
            (res) => {
              if (res?.success) {
                this._connMessageService.showToastMessage('Product deleted successfully.', 'success')
                this._router.navigate(['app/products'])
              } else {
                this._connMessageService.showToastMessage('Product could not be deleted.', 'error')
              }
              this._abd.hideSpinner()
            },
            () => {
              this._abd.hideSpinner()
              this._connMessageService.showToastMessage('Product could not be deleted.', 'error')
            }
          )
        } catch {
          this._abd.hideSpinner()
        }
      }
    })
  }

  makeSaveObject(where2: any) {
    this.syncVariantRowsFromEditor()
    try {
      const abd = this._abd
      const xLimit = 1
      if (abd.departments.length < xLimit || abd.categories.length < xLimit || abd.manufacturers.length < xLimit || abd.vendors.length < xLimit) {
        this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
        return
      }
    } catch {
      this._connMessageService.showToastMessage('No department(s)/category(s)/manufacturer(s) or vendor(s) not available!', 'error');
      return
    }

    // Fallback: if editing and no new uploads, carry over existing images
    if (!this._productService.hasGalleryChanged && !this._productService.thImages.length && this._productService.activeItem?.itemPictures?.length) {
      this._productService.thImages = this._productService.activeItem.itemPictures.map((p: any) => p.picture);
      const flagged = this._productService.activeItem.itemPictures.find((p: any) => p.isFeature || p.isDefault)?.picture;
      let flaggedIndex = flagged ? this._productService.thImages.indexOf(flagged) : -1;
      if (flaggedIndex === -1 && this._productService.thImages.length) {
        flaggedIndex = 0;
      }
      if (flaggedIndex >= 0) {
        this._productService.featureImageIndex = flaggedIndex;
        this._productService.featureImage = this._productService.thImages[flaggedIndex];
      }
    }

    if (this._productService.featureImageIndex === null && this._productService.thImages.length) {
      this._productService.featureImageIndex = 0;
      this._productService.featureImage = this._productService.thImages[0];
    }

    // Map existing thumbnails when editing so we preserve server paths
    const thumbMap = new Map<string, string>();
    const pictureIdMap = new Map<string, string>();
    const pictureItemsIdMap = new Map<string, string>();
    if (this._productService.activeItem?.itemPictures?.length) {
      this._productService.activeItem.itemPictures.forEach((p: any) => {
        if (p?.picture) {
          thumbMap.set(p.picture, p.pictureThumbnail || p.picture);
          if (p?.id) {
            pictureIdMap.set(p.picture, p.id);
          }
          if (p?.itemsId || p?.ItemsId) {
            pictureItemsIdMap.set(p.picture, p.itemsId || p.ItemsId);
          }
        }
      });
    }

    let thfiles: any[] = [];
    let featurePicture: string | null = null;
    let featureThumb: string | null = null;
    let chosenFeatureIndex =
      this._productService.featureImageIndex !== null
        ? this._productService.featureImageIndex
        : -1;
    if (this._productService.thImages.length) {
      let x = 1;
      for (let i = 0; i < this._productService.thImages.length; i++) {
        const f = this._productService.thImages[i];
        if (chosenFeatureIndex < 0 && this._productService.featureImage === f) {
          chosenFeatureIndex = i;
        }
        thfiles.push({
          orderNo: x++,
          picture: f,
          pictureThumbnail: thumbMap.get(f) || f,
          id: pictureIdMap.get(f),
          itemsId: pictureItemsIdMap.get(f) || this._productService.activeItem?.id,
          isFeature: false,
          isDefault: false
        });
      }

      // If no explicit feature was found, force the first image as feature/default
      if (chosenFeatureIndex < 0 && thfiles.length) {
        chosenFeatureIndex = 0;
      }

      if (chosenFeatureIndex >= 0 && thfiles[chosenFeatureIndex]) {
        thfiles = thfiles.map((p, idx) => ({
          ...p,
          isFeature: idx === chosenFeatureIndex,
          isDefault: idx === chosenFeatureIndex,
        }));
        this._productService.featureImageIndex = chosenFeatureIndex;
        this._productService.featureImage = thfiles[chosenFeatureIndex].picture;
      }

      const featureEntry = thfiles.find((p) => p.isFeature) || thfiles[chosenFeatureIndex] || thfiles[0];
      featurePicture = featureEntry?.picture || null;
      featureThumb = featureEntry?.pictureThumbnail || featurePicture;
    } else {
      // Explicitly clear feature when nothing is in the gallery
      this._productService.featureImageIndex = null;
      this._productService.featureImage = null;
    }

    let priceA = this._productService.pts.priceA ? this._productService.pts.priceA : 0
    let priceB = this._productService.pts.priceB ? this._productService.pts.priceB : 0
    let priceC = this._productService.pts.priceC ? this._productService.pts.priceC : 0
    let costPrice = this._productService.pts.costPrice ? this._productService.pts.costPrice : 0
    let caseQty = this._productService.pts.caseQty ? this._productService.pts.caseQty : 0
    let discountPrice = this._productService.pts.discountPrice ? this._productService.pts.discountPrice : 0
    let maxLevel = this._productService.pts.maxLevel ? this._productService.pts.maxLevel : 0
    let minLevel = this._productService.pts.minLevel ? this._productService.pts.minLevel : 0
    let reorderLevel = this._productService.pts.reorderLevel ? this._productService.pts.reorderLevel : 0
    let minOrderQty = this._productService.pts.minOrderQty ? this._productService.pts.minOrderQty : 0
    //  Auto PO
    let maxOrderQty = this._productService.pts.maxOrderQty ? +this._productService.pts.maxOrderQty : 0
    let autoPurchaseOrder = this._productService.pts.autoPurchaseOrder ? this._productService.pts.autoPurchaseOrder : false
    // Auto PO   
    let sp = 0
    if (this._productService.selectedDefaultPrice.value === 1) sp = priceA
    else if (this._productService.selectedDefaultPrice.value === 2) sp = priceB
    else if (this._productService.selectedDefaultPrice.value === 3) sp = priceC

    let sellType = ''
    const selectedSellTypeId = this._abd.selectedProductSellType?.id
    this._productService.isSellOnline = selectedSellTypeId === 1 || selectedSellTypeId === 3
    if (selectedSellTypeId == 1) sellType = 'online'
    else if (selectedSellTypeId == 2) sellType = 'offline'
    else if (selectedSellTypeId == 3) sellType = 'all'

    const selectedDepartment = this._abd.selectedDepartment ?? this._abd.initActDepartments()?.[0] ?? null
    const selectedCategory = this._abd.selectedCategory ?? this._abd.initActCategories()?.[0] ?? null
    const selectedManufacturer = this._abd.selectedManufacturer ?? this._abd.initActManufacturers()?.[0] ?? null
    const selectedVendor = this._abd.selectedVendor ?? this._abd.initActVendors()?.[0] ?? null
    const selectedShippingWeight = this._productService.selectedShippingWeight ?? this._abd.WeightUOM?.[0] ?? null
    const selectedShippingDimension = this._productService.selectedShippingDimension ?? this._abd.DimensionUOM?.[3] ?? this._abd.DimensionUOM?.[0] ?? null

    this._abd.selectedDepartment = selectedDepartment
    this._abd.selectedCategory = selectedCategory
    this._abd.selectedManufacturer = selectedManufacturer
    this._abd.selectedVendor = selectedVendor
    this._productService.selectedShippingWeight = selectedShippingWeight
    this._productService.selectedShippingDimension = selectedShippingDimension

    if (
      selectedDepartment?.id == null ||
      selectedCategory?.id == null ||
      selectedManufacturer?.id == null ||
      selectedVendor?.id == null
    ) {
      this._connMessageService.showToastMessage('Please select department, category, manufacturer, and vendor before saving.', 'error')
      return
    }

    if (selectedShippingWeight?.id == null || selectedShippingDimension?.id == null) {
      this._connMessageService.showToastMessage('Please select shipping weight and dimension units before saving.', 'error')
      return
    }

    const shippingDimention = {
      weightUOM: selectedShippingWeight.id,
      width: this._productService.shippingWidth,
      dimensionUOM: selectedShippingDimension.id,
      height: this._productService.shippingHeight,
      weight: this._productService.shippingWeight,
      length: this._productService.shippingLength,
    }

    const hasVariants = Array.isArray(this._productService.variantAttributes) &&
      this._productService.variantAttributes.length > 0 &&
      Array.isArray(this._productService.variantRows) &&
      this._productService.variantRows.length > 0

    const itemVariantOptions: any[] = []
    const itemVariantOptionValues: any[] = []
    const itemVariantCombinations: any[] = []
    let tempIdSeed = 0
    const nextTempId = () => `tmp-${++tempIdSeed}`
    let tempSkuIdSeed = 1000000
    const nextTempSkuId = () => ++tempSkuIdSeed
    const optionIdByName = new Map<string, any>()
    const valueIdByOptionAndValue = new Map<string, any>()
    const activeItemId = this._productService.activeItem?.id ?? null

    const taxRateValue = this._productService.selectedTaxRate?.value ?? this._productService.taxRates?.[0]?.value ?? null;
    const uomId = this._abd.selectedUom?.id ?? null;
    const baseSkuModel = {
      itemsId: activeItemId || undefined,
      skuCode: this._productService.pts.sku,
      SkuCode: this._productService.pts.sku,
      barcode: this._productService.pts.barcode,
      Barcode: this._productService.pts.barcode,
      //---- 
      // --BST-- 
      barcodes: this.tF.altBarcodes.value,
      skus: this.tF.altSKUs.value,
      tags: this.tF.altTags.value,
      // --BST--
      costPrice: costPrice,
      salePriceA: priceA,
      salePriceB: priceB,
      salePriceC: priceC,
      taxRateId: taxRateValue,
      sellQuantity: this._productService.selectedSellQuantity.value,
      caseQty: caseQty,
      uomId: uomId,
      openingStock: 0,
      defaultPrice: this._productService.selectedDefaultPrice.value,
      title: this._productService.pts.t_productName, //this.__productDetail?.editform.get('productName').value.trim(),
      taxable: this._productService.isTaxable,
      discountPrice: discountPrice,
      shippingDimention: shippingDimention,
      maxLevel: maxLevel,
      minLevel: minLevel,
      reorderLevel: reorderLevel,
      minOrderQty: minOrderQty,
      // Auto PO
      maxOrderQty: maxOrderQty,
      autoPurchaseOrder: autoPurchaseOrder,
      // Auto PO
    }

    let skus = []
    let os = []

      if (hasVariants) {
        const variantRows = this._productService.variantRows || []
        const variantAttributes = Array.isArray(this._productService.variantAttributes)
          ? this._productService.variantAttributes
          : []
        const useParentSkuBarcode = this._productService.useParentSkuBarcodeForVariants === true
        const parentSku = String(this._productService.pts.sku ?? '').trim()
        const parentBarcode = String(this._productService.pts.barcode ?? '').trim()
        const existingOptionModels = this._productService.activeItem?.ItemVariantOptions
          ?? this._productService.activeItem?.itemVariantOptions
          ?? []
        const existingValueModels = this._productService.activeItem?.ItemVariantOptionValues
          ?? this._productService.activeItem?.itemVariantOptionValues
          ?? []
      const locationList = this._productService.selectedLocations || []
      const locationIds = locationList
        .map((loc) => this.resolveLocationIdentifier(loc))
        .filter((id) => id !== null && id !== undefined)
      const fallbackLocationId = locationIds[0]
      const variantStocks = this._productService.variantLocationStocks || {}
      const variantQohStocks = this._productService.variantLocationQohStocks || {}
      const variantImageByRowId = new Map<string, string>()
      const variantImageByOptions = new Map<string, string>()
      const existingSkuImageByCode = new Map<string, string>()
      const variantValueMetaByOptionAndValue = new Map<string, { storageValue: string; sortOrder: number }>()
      const pushedVariantValueKeys = new Set<string>()
      const buildOptionsSignature = (options: Record<string, any>) => {
        const entries = Object.entries(options || {})
          .map(([key, val]) => [String(key || '').trim().toLowerCase(), String(val ?? '').trim().toLowerCase()] as [string, string])
          .filter(([key, val]) => !!key && !!val)
          .sort(([a], [b]) => a.localeCompare(b))
        return entries.map(([key, val]) => `${key}:${val}`).join('|')
      }
      const variantImageEntries = Array.isArray(this._productService.variantImages)
        ? this._productService.variantImages
        : []
      variantImageEntries.forEach((entry: any) => {
        const image = String(entry?.image ?? '').trim()
        if (!image) return
        const rowId = String(entry?.id ?? '').trim()
        if (rowId) {
          variantImageByRowId.set(rowId, image)
        }
        const optionsSignature = buildOptionsSignature(entry?.options || {})
        if (optionsSignature) {
          variantImageByOptions.set(optionsSignature, image)
        }
      })

        if (Array.isArray(existingOptionModels) && existingOptionModels.length) {
          existingOptionModels.forEach((option: any) => {
            const optionId = option?.Id ?? option?.id ?? option?.OptionId ?? option?.optionId
            const optionName = option?.OptionName ?? option?.optionName ?? option?.Name ?? option?.name ?? ''
            if (optionName && optionId !== undefined && optionId !== null) {
              optionIdByName.set(optionName, optionId)
            }
          })
        }

        const existingSkuModels = this.getItemSkuList(this._productService.activeItem)
        if (Array.isArray(existingSkuModels) && existingSkuModels.length) {
          existingSkuModels.forEach((sku: any) => {
            const skuCode = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim()
            const image = String(sku?.skuImage ?? sku?.SKUImage ?? sku?.image ?? sku?.Image ?? '').trim()
            if (skuCode && image) {
              existingSkuImageByCode.set(skuCode, image)
            }
          })
        }

        if (Array.isArray(existingValueModels) && existingValueModels.length) {
          existingValueModels.forEach((value: any) => {
            const optionId = value?.OptionId ?? value?.optionId
            const display = value?.DisplayValue ?? value?.displayValue ?? value?.Value ?? value?.value ?? ''
            const valueId = value?.Id ?? value?.id ?? value?.OptionValueId ?? value?.optionValueId
            if (optionId !== undefined && optionId !== null && display && valueId !== undefined && valueId !== null) {
              valueIdByOptionAndValue.set(`${optionId}|${display}`, valueId)
            }
          })
        }

        variantAttributes.forEach((option: any, index: number) => {
          const optionName = option?.name ?? option?.Name ?? ''
          if (!optionName) return
          const existingOptionId = optionIdByName.get(optionName)
          const optionId = option?.id ?? option?.Id ?? option?.optionId ?? option?.OptionId ?? existingOptionId ?? nextTempId()
          optionIdByName.set(optionName, optionId)
          itemVariantOptions.push({
            id: optionId,
            itemsId: activeItemId || undefined,
            optionName: optionName,
            sortOrder: option?.position ?? option?.SortOrder ?? index + 1
          })
          const values = Array.isArray(option?.values) ? option.values : []
          const valueIds = option?.valueIds ?? option?.ValueIds ?? {}
          values.forEach((value: string, valueIndex: number) => {
            const displayValue = String(value ?? '').trim()
            if (!displayValue) return
            const storageValue = this.getVariantOptionStorageValue(optionName, displayValue)
            const existingValueId = valueIdByOptionAndValue.get(`${optionId}|${displayValue}`)
            const valueId = valueIds?.[displayValue] ?? valueIds?.[storageValue] ?? existingValueId ?? nextTempId()
            valueIdByOptionAndValue.set(`${optionId}|${displayValue}`, valueId)
            variantValueMetaByOptionAndValue.set(`${optionId}|${displayValue}`, {
              storageValue,
              sortOrder: valueIndex + 1
            })
        })
      })

      const getVariantLabel = (row: any) => {
        if (!row?.options) return ''
        return Object.values(row.options).join(' / ')
      }

      const buildRowIdFromOptions = (row: any) => {
        const optionOrder = variantAttributes
          .map((opt: any) => opt?.name ?? opt?.Name ?? '')
          .filter((name: string) => !!name)
        if (!optionOrder.length || !row?.options) return ''
        return optionOrder
          .map((name: string) => `${name}:${row.options[name] ?? ''}`)
          .join('|')
      }

      const resolveVariationId = (row: any) => {
        const isGuid = (value: any) =>
          typeof value === 'string' &&
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value)
        const isNumericValue = (value: any) => {
          if (typeof value === 'number') return Number.isFinite(value)
          if (typeof value !== 'string') return false
          const trimmed = value.trim()
          return trimmed !== '' && /^[0-9]+$/.test(trimmed)
        }
        const isValidSkuId = (value: any) => isNumericValue(value) || isGuid(value)

        const explicitVariationId = row?.id ?? row?.variationId ?? row?.variantId
        if (isValidSkuId(explicitVariationId)) {
          return explicitVariationId
        }
        const existingId =
          row?.skuId
          ?? row?.itemSKUId
          ?? row?.itemSkuId
          ?? row?.ItemSKUId
          ?? row?.ItemSkuId
          ?? row?.SKUId
          ?? row?.skuID
          ?? row?.Id
          ?? row?.id
        if (isValidSkuId(existingId)) {
          return existingId
        }
        return nextTempSkuId()
      }

        for (const row of variantRows) {
          const rowAny: any = row
          const rowSku = String(rowAny?.sku ?? rowAny?.skuCode ?? rowAny?.SkuCode ?? '').trim()
          const rowBarcode = String(row?.barcode ?? '').trim()
          const skuCode = useParentSkuBarcode
            ? (parentSku || rowSku)
            : (rowSku || String(this._productService.pts.sku ?? '').trim() || this._globals.generateSKU())
          const barcode = useParentSkuBarcode
            ? (parentBarcode || rowBarcode)
            : (rowBarcode || String(this._productService.pts.barcode ?? '').trim() || this._globals.generateSKU())
          const variationId = resolveVariationId(row)
          const variantPrice = row?.price ?? sp ?? 0
          const variantLabel = getVariantLabel(row)
          const rowId = String(row?.id ?? '').trim()
          const rowOptionsSignature = buildOptionsSignature(row?.options || {})
          const hasExplicitRowImage = !!row && Object.prototype.hasOwnProperty.call(row, 'image')
          const explicitRowImage = typeof row?.image === 'string' ? row.image.trim() : ''
          const resolvedImage = hasExplicitRowImage
            ? (explicitRowImage || null)
            : (
              (rowId ? variantImageByRowId.get(rowId) : undefined)
              || (rowOptionsSignature ? variantImageByOptions.get(rowOptionsSignature) : undefined)
              || existingSkuImageByCode.get(skuCode)
              || null
            )
          const rowShippingDimention = {
            // Weight Unit is a single product-wide setting now (variants toolbar), not per-row —
            // always send the product-level unit so a stale per-variant value from before this
            // change can't override it.
            weightUOM: shippingDimention.weightUOM,
            width: rowAny?.shippingWidth ?? shippingDimention.width,
            dimensionUOM: rowAny?.shippingDimensionUOM ?? shippingDimention.dimensionUOM,
            height: rowAny?.shippingHeight ?? shippingDimention.height,
            weight: rowAny?.shippingWeight ?? shippingDimention.weight,
            length: rowAny?.shippingLength ?? shippingDimention.length,
          }
          const skuEntry: any = {
            ...baseSkuModel,
            skuCode,
            SkuCode: skuCode,
            barcode,
            Barcode: barcode,
            SKUImage: resolvedImage,
            salePriceA: variantPrice,
            shippingDimention: rowShippingDimention,
            title: variantLabel
              ? `${this._productService.pts.t_productName} - ${variantLabel}`
              : this._productService.pts.t_productName
          }
          skuEntry.id = variationId
          skus.push(skuEntry)

          const optionEntries = Object.entries(row?.options || {})
          for (const [optionName, optionValue] of optionEntries) {
            if (!optionName || !optionValue) continue
            const displayValue = String(optionValue).trim()
            if (!displayValue) continue
            const storageValue = this.getVariantOptionStorageValue(optionName, displayValue)
            let optionId = optionIdByName.get(optionName)
            if (optionId === undefined) {
              optionId = nextTempId()
              optionIdByName.set(optionName, optionId)
              itemVariantOptions.push({
                id: optionId,
                itemsId: activeItemId || undefined,
                optionName: optionName,
                sortOrder: itemVariantOptions.length + 1
              })
            }
            let valueId = valueIdByOptionAndValue.get(`${optionId}|${displayValue}`)
            if (valueId === undefined) {
              valueId = nextTempId()
              valueIdByOptionAndValue.set(`${optionId}|${displayValue}`, valueId)
            }
            const pushedValueKey = `${optionId}|${displayValue}`
            if (!pushedVariantValueKeys.has(pushedValueKey)) {
              pushedVariantValueKeys.add(pushedValueKey)
              const valueMeta = variantValueMetaByOptionAndValue.get(pushedValueKey)
              itemVariantOptionValues.push({
                id: valueId,
                optionId: optionId,
                itemsId: activeItemId || undefined,
                value: valueMeta?.storageValue ?? storageValue,
                displayValue: displayValue,
                sortOrder: valueMeta?.sortOrder ?? itemVariantOptionValues.length + 1
              })
            }
            itemVariantCombinations.push({
              itemSKUId: variationId,
              itemsId: activeItemId || undefined,
              optionId: optionId,
              optionValueId: valueId
            })
          }

          for (const locationId of locationIds) {
            let quantity = this._productService.isNew
              ? this.getVariantOpeningStockForLocation(variantStocks, locationId, row)
              : this.getVariantOpeningStockForLocation(variantQohStocks, locationId, row)
            if ((quantity === undefined || quantity === null) && !this._productService.isNew) {
              quantity = this.getVariantOpeningStockForLocation(variantStocks, locationId, row)
            }
            if (quantity === undefined || quantity === null) {
              quantity = locationId === fallbackLocationId
                ? (row.available ?? 0)
                : 0
            }
            os.push({
              locationId: locationId,
              skuCode: skuCode,
              SkuCode: skuCode,
              quantity: quantity
            })
          }
        }
    } else {
      const existingSkuId = !this._productService.isNew
        ? (this._productService.activeItem?.ItemSKUs?.[0]?.id
          ?? this._productService.activeItem?.ItemSKUs?.[0]?.Id
          ?? this._productService.activeItem?.crsItemSKUs?.[0]?.id
          ?? this._productService.activeItem?.crsItemSKUs?.[0]?.Id
          ?? this._productService.activeItem?.itemSKUs?.[0]?.id
          ?? this._productService.activeItem?.itemSKUs?.[0]?.Id
          ?? this._productService.pts?.itemSKUId
          ?? null)
        : null
      const skuIdToUse = this._productService.isNew ? undefined : (existingSkuId ?? undefined)
      skus.push({
        ...baseSkuModel,
        id: skuIdToUse
      })
      try {
        if (this._productService.selectedLocations && this._productService.selectedLocations.length > 0) {
          for (let l of this._productService.selectedLocations) {
            let qty = 0
            if (this._productService.isNew) qty = l.openingStock
            else qty = l.stockOnHand

            const resolvedLocationId = this.resolveLocationIdentifier(l)
            if (resolvedLocationId === null || resolvedLocationId === undefined) continue

            const model = {
              locationId: resolvedLocationId,
              skuCode: this._productService.pts.sku,
              SkuCode: this._productService.pts.sku,
              quantity: qty
            }
            os.push(model)
          }
        }
      } catch { }
    }

    os = this.buildOpeningStockChangePayload(os)

    const createdAt = this._productService.isNew
      ? new Date()
      : this._productService.activeItem?.createdAt
        || this._productService.activeItem?.createdDate
        || this._productService.activeItem?.createdOn
        || new Date()
    const lastEdited = new Date()

    const finalImage = this._productService.thImages.length ? featurePicture : null;
    const finalThumb = this._productService.thImages.length ? featureThumb : null;

    const model = {
      "itemName": this._productService.pts.t_productName, //this.__productDetail?.editform.get('productName').value.trim(),
      "notes": this._productService.productNotes.trim(),
      "descriptionURL": this._productService.pts.descriptionUrl,
      "itemType": this._productService.selectedProductType.value,
      "soldAs": this._productService.selectedSellAs.value,
      "ageRestriction": this._productService.selectedAgeRestriction.value,
      "gender": this._productService.selectedGender.value,
      "allowDiscount": this._productService.selectedDiscount.value,
      "isTaxable": this._productService.isTaxable,
      "isOpnDept": this._productService.isOpenPrice,
      "showNotesWhen": this._productService.ShowNotesWhenRingingItem,
      "printOnInvoice": this._productService.printNotesOnReceipt,
      "printAsQRCodeOnReceipt": this._productService.isPrintAsQR,
      "trackStock": this._productService.isTrackStock,
      "isActive": true,
      "createdAt": createdAt,
      "lastEdited": lastEdited,
      "addedBy": this._globals.userInfo.userID,
      "departmentId": selectedDepartment.id,
      "categoryId": selectedCategory.id,
      "manufacturerId": selectedManufacturer.id,
      "vendorId": selectedVendor.id,
      "allowNegativeStock": this._productService.isAllowNegativeStock,
      "description": this._productService.productDescription,
      "image": finalImage,
      "imageThumbnail": finalThumb,
      "grouping": this._productService.selectedGrouping.value,
      "isVariantProduct": hasVariants,
      "crsItemSKUs": skus,
      "itemVariantOptions": itemVariantOptions,
      "itemVariantOptionValues": itemVariantOptionValues,
      "itemVariantCombinations": itemVariantCombinations,
      "openingStocks": os,
      "itemPictures": thfiles,
      "sellOnline": this._productService.isSellOnline,
      "productSellType": sellType,
      "isReturnable": this._productService.isReturnable,
    }

    this.debugProductV3Payload(model, this.isNew ? 'create' : 'update')

    let saved = false
    if (this.isNew) {
      try {
        this._abd.showSpinner()
        this._productService.saveProductV3(model).subscribe(res => {
          if (res.success) {
            this.saveLabel(model)
            this._productService.notifyFirstProductCreated()

            this._connMessageService.showToastMessage('Product saved successfully.', 'success');
            saved = true
            this._abd.hideSpinner()
            if (where2 == 'save-only')
              window.history.back()
          } else {
            this._abd.hideSpinner()
            this._connMessageService.showToastMessage(res?.message || 'Could not save the product.', 'error')
          }
        }, () => this._abd.hideSpinner())
      } catch { this._abd.hideSpinner() }
      finally { }
    } else {
      try {
        this._abd.showSpinner()
        this._productService.updateProductV3(model, this._productService.activeItem.id).subscribe(res => {
          if (res.success) {
            this.saveLabel(model)
            this._productService.selectedLocations = []
            let loc = this._abd.locations
            for (let i = 0; i < loc.length; i++) {
              try {
                delete loc[i].newQoh
              }
              catch { }
            }

            this._connMessageService.showToastMessage('Product updated successfully.', 'success');
            saved = true
            if (where2 == 'save-only') {
              window.history.back()
            }
            this._abd.hideSpinner()
          } else {
            this._abd.hideSpinner()
            this._connMessageService.showToastMessage(res?.message || 'Could not update the product.', 'error')
          }
        }, () => this._abd.hideSpinner())
      } catch { this._abd.hideSpinner() }
      finally {

      }
    }
  }

  private debugProductV3Payload(model: any, mode: 'create' | 'update') {
    try {
      const payload = JSON.parse(JSON.stringify(model))
      ;(window as any).__lastProductV3Payload = payload

      console.groupCollapsed(`[Product V3 ${mode}] payload`)
      console.log('Object:', payload)
      console.log('JSON:', JSON.stringify(payload, null, 2))
      console.groupEnd()
    } catch (error) {
      console.error('[Product V3 payload debug] Unable to serialize payload', error, model)
    }
  }

  private syncVariantRowsFromEditor(): void {
    try {
      const editorRows = (this.__productVariants as any)?.variantRows
      if (!Array.isArray(editorRows)) return
      this._productService.variantRows = editorRows.map((row: any) => ({
        ...row,
        sku: String(row?.sku ?? row?.skuCode ?? row?.SkuCode ?? '').trim(),
        skuCode: String(row?.sku ?? row?.skuCode ?? row?.SkuCode ?? '').trim(),
        SkuCode: String(row?.sku ?? row?.skuCode ?? row?.SkuCode ?? '').trim(),
        barcode: String(row?.barcode ?? row?.Barcode ?? '').trim()
      }))
    } catch { }
  }

  // goToRoute() {
  //   let p = null;

  //   this._route.queryParams.subscribe(params => {
  //     p = params['p']; 
  //   });
  //   if(p !== undefined){
  //     if(p.includes('list')){
  //      this._router.navigate([""])
  //     }
  //   }
  // }
  //  Label Printing
  saveLabel(value?: any) {
    const selectedLocations = Array.isArray(this.f.locations?.value) ? this.f.locations.value : []
    const copyCount = this.f.noOfCopy?.value
    const hasPrinterSelection = !!(
      this.selectedBrand?.brand &&
      this.selectedBrand?.model &&
      this.selectedlabelSizes?.name &&
      this.selectedlabelStyle?.name
    )

    if (this.labelForm.valid && selectedLocations.length > 0 && copyCount !== "" && hasPrinterSelection) {
      this._abd.showSpinner()
      let objList = selectedLocations.map((loc) => {

        let locId = this.f.location?.value?.locationId ?? this.f.location?.value?.id
        let location = (this._abd.locations || []).find((val) => {
          const currentId = val?.locationId ?? val?.id
          return String(currentId ?? '') === String(locId ?? '')
        })
        let address = location
          ? `${location.locationName || ''}, ${location.address || ''},${location.city || ''}, ${location.state || ''}, ${location.zip || ''}`
          : ''


        const sku = value?.crsItemSKUs?.[0] ?? {};
        const labelPrice =
          sku?.salePrice ??
          sku?.salePriceA ??
          sku?.salePriceB ??
          sku?.salePriceC ??
          0;

        return {
          printerBrand: this.selectedBrand.brand,
          printerModel: this.selectedBrand.model,
          labelSize: this.selectedlabelSizes.name,
          barcodeStyle: this.selectedlabelStyle.name,
          ProductName: value.itemName,
          Barcode: sku?.barcode,
          Sku: sku?.skuCode,
          Location: loc.id,
          Business: this._globals.userInfo?.businessSetup[0].businessName,
          Price: labelPrice,
          LocationName: address,
          LocationId: this.f.location?.value?.id ?? this.f.location?.value?.locationId ?? null,
          NoOfCopy: +copyCount,
          TemplateId: 0,
          iscustom: 1,
          BrandImage: this._productService.labelPrintingImage,
          Status: '0',
        }
      })
      this._barcodeLabelServices.saveBarcodeLabel(objList).subscribe(res => {
        if (res.success) {
          this._abd.hideSpinner();
          this._connMessageService.showToastMessage('Product Label Printing saved successfully', 'success');
        }
        else {
          this._connMessageService.showToastMessage(`Product Label Printing could not be saved.`, 'error');
          this._abd.hideSpinner()
        }
      }, (error) => {
        this._abd.hideSpinner()
      })
    }
  }

  // /Label Printing
  async makeThFiles_1() {
    this.thFiles = []
    let files = []
    const self = this


    if (!this.fileInput) return
    if (!this.fileInput.files) return

    for (let file of this.fileInput.files) {
      var fileToLoad = file;
      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result; // <--- data: base64

        var newImage = document.createElement('img');
        newImage.src = <any>srcData;

        // document.getElementById("imgTest").innerHTML = newImage.outerHTML;

        self.thFiles.push(srcData)
        //alert("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
        // //console.log("Converted Base64 version is " + document.getElementById("imgTest").innerHTML);
      }
      fileReader.readAsDataURL(fileToLoad);
    }
  }

  validToSave() {
    let variantsValid = true;
    try {
      if (this.__productDetail)
        this._productService.validate.pd = this.__productDetail?.isFormValid()
      if (this.__productPricing)
        this._productService.validate.pp = this.__productPricing?.isFormValid()
      if (this.__productInventory)
        this._productService.validate.pi = this.__productInventory?.isFormValid()
      if (this.__productVariants && this._productService.variantRows?.length) {
        variantsValid = this.__productVariants.isFormValid();
      }
    } catch { }
    //console.log('valid-DD', this._productService.validate.pp)

    return (
      this._productService.validate.pd &&
      this._productService.validate.pp &&
      this._productService.validate.pi
      && this.tagsForm.valid
      && variantsValid
    )
  }

  cancelClick() {
    if (this.isEmbeddedView) {
      this.closeEmbedded.emit()
      return
    }

    this._abd.selectedProductSellTypeFilter = this._productService.filter.selectedProductSellTypeFilter
    this._abd.selectedLocation = this._productService.filter.selectedLocation
    this._abd.selectedDepartment = this._productService.filter.selectedDepartment
    this._abd.selectedCategory = this._productService.filter.selectedCategory
    this._abd.selectedVendor = this._productService.filter.selectedVendor
    this._abd.selectedManufacturer = this._productService.filter.selectedManufacturer

    this._productService.isNewVendor = false
    this._router.navigate(['app/products-v2'])
  }

}
